
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return n(r, t, e, u, i);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return function(a) {
                                return n(r, t, e, u, i, a);
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, i) {
        return 5 === n.a ? n.f(r, t, e, u, i) : n(r)(t)(e)(u)(i);
    }
    function A6(n, r, t, e, u, i, a) {
        return 6 === n.a ? n.f(r, t, e, u, i, a) : n(r)(t)(e)(u)(i)(a);
    }
    var t = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), e = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, c(t, r);
    });
    function u(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function i(n, r) {
        for(var t, e = [], u = a(n, r, 0, e); u && (t = e.pop()); u = a(t.a, t.b, 0, e));
        return u;
    }
    function a(n, r, t, e) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && u(5), !1;
        if (t > 100) return e.push(c(n, r)), !0;
        for(var i in 0 > n.$ && (n = br(n), r = br(r)), n)if (!a(n[i], r[i], t + 1, e)) return !1;
        return !0;
    }
    function o(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = o(n.a, r.a)) || (t = o(n.b, r.b)) ? t : o(n.c, r.c);
        for(; n.b && r.b && !(t = o(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    var f = F2(function(n, r) {
        var t = o(n, r);
        return 0 > t ? hr : t ? dr : lr;
    });
    function c(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function s(n, r, t) {
        return {
            a: n,
            b: r,
            c: t
        };
    }
    function v(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function b(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = d(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = d(n.a, r);
        return t;
    }
    var l = {
        $: 0
    };
    function d(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var h = F2(d);
    function g(n) {
        for(var r = l, t = n.length; t--;)r = d(n[t], r);
        return r;
    }
    function $(n) {
        for(var r = []; n.b; n = n.b)r.push(n.a);
        return r;
    }
    var p = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return g(e);
    }), m = F2(function(n, r) {
        return g($(r).sort(function(r, t) {
            return o(n(r), n(t));
        }));
    }), w = F2(function(n, r) {
        return n + r;
    }), x = F2(function(n, r) {
        return n * r;
    }), y = Math.ceil, k = Math.floor, A = Math.log, j = F2(function(n, r) {
        return n + r;
    }), _ = F3(function(n, r, t) {
        for(var e = t.length; e--;){
            var u = t[e], i = t.charCodeAt(e);
            56320 > i || i > 57343 || (u = t[--e] + u), r = A2(n, u, r);
        }
        return r;
    }), E = F3(function(n, r, t) {
        return t.slice(n, r);
    });
    function N(n) {
        return n + "";
    }
    function z(n) {
        return {
            $: 2,
            b: n
        };
    }
    var H = z(function(n) {
        return "number" != typeof n ? q("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? wr(n) : !isFinite(n) || n % 1 ? q("an INT", n) : wr(n);
    }), F = z(function(n) {
        return "boolean" == typeof n ? wr(n) : q("a BOOL", n);
    }), L = (z(function(n) {
        return "number" == typeof n ? wr(n) : q("a FLOAT", n);
    }), z(function(n) {
        return wr(n);
    }), z(function(n) {
        return "string" == typeof n ? wr(n) : n instanceof String ? wr(n + "") : q("a STRING", n);
    })), W = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function T(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var C = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), P = F2(function(n, r) {
        return T(n, [
            r
        ]);
    }), O = F3(function(n, r, t) {
        return T(n, [
            r,
            t
        ]);
    }), M = F2(function(n, r) {
        return B(n, r);
    });
    function B(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? wr(n.c) : q("null", r);
            case 3:
                return S(r) ? Q(n.b, r, g) : q("a LIST", r);
            case 4:
                return S(r) ? Q(n.b, r, R) : q("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return q("an OBJECT with a field named `" + t + "`", r);
                var e = B(n.b, r[t]);
                return Kr(e) ? e : gr(A2(pr, t, e.a));
            case 7:
                var u = n.e;
                return S(r) ? r.length > u ? (e = B(n.b, r[u]), Kr(e) ? e : gr(A2(mr, u, e.a))) : q("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : q("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || S(r)) return q("an OBJECT", r);
                var i = l;
                for(var a in r)if (r.hasOwnProperty(a)) {
                    if (e = B(n.b, r[a]), !Kr(e)) return gr(A2(pr, a, e.a));
                    i = d(c(a, e.a), i);
                }
                return wr(Lr(i));
            case 9:
                for(var o = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (e = B(f[s], r), !Kr(e)) return e;
                    o = o(e.a);
                }
                return wr(o);
            case 10:
                return e = B(n.b, r), Kr(e) ? B(n.h(e.a), r) : e;
            case 11:
                for(var v = l, b = n.g; b.b; b = b.b){
                    if (e = B(b.a, r), Kr(e)) return e;
                    v = d(e.a, v);
                }
                return gr(xr(Lr(v)));
            case 1:
                return gr(A2($r, n.a, r));
            case 0:
                return wr(n.a);
        }
    }
    function Q(n, r, t) {
        for(var e = r.length, u = Array(e), i = 0; e > i; i++){
            var a = B(n, r[i]);
            if (!Kr(a)) return gr(A2(mr, i, a.a));
            u[i] = a.a;
        }
        return wr(t(u));
    }
    function S(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function R(n) {
        return A2(Ur, n.length, function(r) {
            return n[r];
        });
    }
    function q(n, r) {
        return gr(A2($r, "Expecting " + n, r));
    }
    function D(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return D(n.b, r.b);
            case 6:
                return n.d === r.d && D(n.b, r.b);
            case 7:
                return n.e === r.e && D(n.b, r.b);
            case 9:
                return n.f === r.f && Y(n.g, r.g);
            case 10:
                return n.h === r.h && D(n.b, r.b);
            case 11:
                return Y(n.g, r.g);
        }
    }
    function Y(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!D(n[e], r[e])) return !1;
        return !0;
    }
    function G(n) {
        return n;
    }
    function I(n) {
        return {
            $: 0,
            a: n
        };
    }
    function V(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var X = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), Z = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), J = 0;
    function U(n) {
        var r = {
            $: 0,
            e: J++,
            f: n,
            g: null,
            h: []
        };
        return un(r), r;
    }
    function K(n) {
        return V(function(r) {
            r(I(U(n)));
        });
    }
    function nn(n, r) {
        n.h.push(r), un(n);
    }
    var rn = F2(function(n, r) {
        return V(function(t) {
            nn(n, r), t(I(0));
        });
    }), tn = !1, en = [];
    function un(n) {
        if (en.push(n), !tn) {
            for(tn = !0; n = en.shift();)an(n);
            tn = !1;
        }
    }
    function an(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, un(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var on = {};
    function fn(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function cn(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, i = n.e, a = n.f;
        function o(n) {
            return A2(X, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(u, t, o, n) : i && a ? A4(e, t, o.i, o.j, n) : A3(e, t, i ? o.i : o.j, n);
                }
            });
        }
        return t.h = U(A2(X, o, n.b));
    }
    var sn = F2(function(n, r) {
        return V(function(t) {
            n.g(r), t(I(0));
        });
    }), vn = F2(function(n, r) {
        return A2(rn, n.h, {
            $: 0,
            a: r
        });
    });
    function bn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function ln(n) {
        return {
            $: 2,
            m: n
        };
    }
    var dn = [], hn = !1;
    function gn(n, r, t) {
        if (dn.push({
            p: n,
            q: r,
            r: t
        }), !hn) {
            hn = !0;
            for(var e; e = dn.shift();)$n(e.p, e.q, e.r);
            hn = !1;
        }
    }
    function $n(n, r, t) {
        var e = {};
        for(var u in pn(!0, r, e, null), pn(!1, t, e, null), n)nn(n[u], {
            $: "fx",
            a: e[u] || {
                i: l,
                j: l
            }
        });
    }
    function pn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, i = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? on[r].e : on[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: l,
                        j: l
                    }, n ? t.i = d(r, t.i) : t.j = d(r, t.j), t;
                }(n, i, t[u]));
            case 2:
                for(var a = r.m; a.b; a = a.b)pn(n, a.a, t, e);
                return;
            case 3:
                return void pn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var mn = "undefined" != typeof document ? document : {};
    function wn(n, r) {
        n.appendChild(r);
    }
    function xn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var yn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], i = 0; e.b; e = e.b){
                var a = e.a;
                i += a.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 1,
                c: r,
                d: zn(t),
                e: u,
                f: n,
                b: i
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], i = 0; e.b; e = e.b){
                var a = e.a;
                i += a.b.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 2,
                c: r,
                d: zn(t),
                e: u,
                f: n,
                b: i
            };
        });
    })(void 0);
    var kn, An = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), jn = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), _n = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), En = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    }), Nn = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function zn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, i = t.o;
            if ("a2" !== e) {
                var a = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? Hn(a, u, i) : a[u] = i;
            } else "className" === u ? Hn(r, u, i) : r[u] = i;
        }
        return r;
    }
    function Hn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function Fn(n, r) {
        var t = n.$;
        if (5 === t) return Fn(n.k || (n.k = n.m()), r);
        if (0 === t) return mn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var i = {
                j: u,
                p: r
            };
            return (a = Fn(e, i)).elm_event_node_ref = i, a;
        }
        if (3 === t) return Ln(a = n.h(n.g), r, n.d), a;
        var a = n.f ? mn.createElementNS(n.f, n.c) : mn.createElement(n.c);
        Ln(a, r, n.d);
        for(var o = n.e, f = 0; o.length > f; f++)wn(a, Fn(1 === t ? o[f] : o[f].b, r));
        return a;
    }
    function Ln(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Wn(n, u) : "a0" === e ? Pn(n, r, u) : "a3" === e ? Tn(n, u) : "a4" === e ? Cn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function Wn(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function Tn(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function Cn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, i = e.o;
            void 0 !== i ? n.setAttributeNS(u, t, i) : n.removeAttributeNS(u, t);
        }
    }
    function Pn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var i = t[u], a = e[u];
            if (i) {
                if (a) {
                    if (a.q.$ === i.$) {
                        a.q = i;
                        continue;
                    }
                    n.removeEventListener(u, a);
                }
                a = On(r, i), n.addEventListener(u, a, kn && {
                    passive: 2 > ut(i)
                }), e[u] = a;
            } else n.removeEventListener(u, a), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                kn = !0;
            }
        }));
    } catch (n) {}
    function On(n, r) {
        function t(r) {
            var e = t.q, u = B(e.a, r);
            if (Kr(u)) {
                for(var i, a = ut(e), o = u.a, f = a ? 3 > a ? o.a : o.y : o, c = 1 == a ? o.b : 3 == a && o.ag, s = (c && r.stopPropagation(), (2 == a ? o.b : 3 == a && o.ad) && r.preventDefault(), n); i = s.j;){
                    if ("function" == typeof i) f = i(f);
                    else for(var v = i.length; v--;)f = i[v](f);
                    s = s.p;
                }
                s(f, c);
            }
        }
        return t.q = r, t;
    }
    function Mn(n, r) {
        return n.$ == r.$ && D(n.a, r.a);
    }
    function Bn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function Qn(n, r, t, e) {
        if (n !== r) {
            var u = n.$, i = r.$;
            if (u !== i) {
                if (1 !== u || 2 !== i) return void Bn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), i = 1;
            }
            switch(i){
                case 5:
                    for(var a = n.l, o = r.l, f = a.length, c = f === o.length; c && f--;)c = a[f] === o[f];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return Qn(n.k, r.k, s, 0), void (s.length > 0 && Bn(t, 1, e, s));
                case 4:
                    for(var v = n.j, b = r.j, l = !1, d = n.k; 4 === d.$;)l = !0, "object" != typeof v ? v = [
                        v,
                        d.j
                    ] : v.push(d.j), d = d.k;
                    for(var h = r.k; 4 === h.$;)l = !0, "object" != typeof b ? b = [
                        b,
                        h.j
                    ] : b.push(h.j), h = h.k;
                    return l && v.length !== b.length ? void Bn(t, 0, e, r) : ((l ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(v, b) : v === b) || Bn(t, 2, e, b), void Qn(d, h, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Bn(t, 3, e, r.a));
                case 1:
                    return void Sn(n, r, t, e, qn);
                case 2:
                    return void Sn(n, r, t, e, Dn);
                case 3:
                    if (n.h !== r.h) return void Bn(t, 0, e, r);
                    var g = Rn(n.d, r.d);
                    g && Bn(t, 4, e, g);
                    var $ = r.i(n.g, r.g);
                    return void ($ && Bn(t, 5, e, $));
            }
        }
    }
    function Sn(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var i = Rn(n.d, r.d);
            i && Bn(t, 4, e, i), u(n, r, t, e);
        } else Bn(t, 0, e, r);
    }
    function Rn(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var i = n[u], a = r[u];
                i === a && "value" !== u && "checked" !== u || "a0" === t && Mn(i, a) || ((e = e || {})[u] = a);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var o = Rn(n[u], r[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var f in r)f in n || ((e = e || {})[f] = r[f]);
        return e;
    }
    function qn(n, r, t, e) {
        var u = n.e, i = r.e, a = u.length, o = i.length;
        a > o ? Bn(t, 6, e, {
            v: o,
            i: a - o
        }) : o > a && Bn(t, 7, e, {
            v: a,
            e: i
        });
        for(var f = o > a ? a : o, c = 0; f > c; c++){
            var s = u[c];
            Qn(s, i[c], t, ++e), e += s.b || 0;
        }
    }
    function Dn(n, r, t, e) {
        for(var u = [], i = {}, a = [], o = n.e, f = r.e, c = o.length, s = f.length, v = 0, b = 0, l = e; c > v && s > b;){
            var d = (_ = o[v]).a, h = (E = f[b]).a, g = _.b, $ = E.b, p = void 0, m = void 0;
            if (d !== h) {
                var w = o[v + 1], x = f[b + 1];
                if (w) {
                    var y = w.a, k = w.b;
                    m = h === y;
                }
                if (x) {
                    var A = x.a, j = x.b;
                    p = d === A;
                }
                if (p && m) Qn(g, j, u, ++l), Gn(i, u, d, $, b, a), l += g.b || 0, In(i, u, d, k, ++l), l += k.b || 0, v += 2, b += 2;
                else if (p) l++, Gn(i, u, h, $, b, a), Qn(g, j, u, l), l += g.b || 0, v += 1, b += 2;
                else if (m) In(i, u, d, g, ++l), l += g.b || 0, Qn(k, $, u, ++l), l += k.b || 0, v += 2, b += 1;
                else {
                    if (!w || y !== A) break;
                    In(i, u, d, g, ++l), Gn(i, u, h, $, b, a), l += g.b || 0, Qn(k, j, u, ++l), l += k.b || 0, v += 2, b += 2;
                }
            } else Qn(g, $, u, ++l), l += g.b || 0, v++, b++;
        }
        for(; c > v;){
            var _;
            l++, In(i, u, (_ = o[v]).a, g = _.b, l), l += g.b || 0, v++;
        }
        for(; s > b;){
            var E, N = N || [];
            Gn(i, u, (E = f[b]).a, E.b, void 0, N), b++;
        }
        (u.length > 0 || a.length > 0 || N) && Bn(t, 8, e, {
            w: u,
            x: a,
            y: N
        });
    }
    var Yn = "_elmW6BL";
    function Gn(n, r, t, e, u, i) {
        var a = n[t];
        if (!a) return i.push({
            r: u,
            A: a = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = a);
        if (1 === a.c) {
            i.push({
                r: u,
                A: a
            }), a.c = 2;
            var o = [];
            return Qn(a.z, e, o, a.r), a.r = u, void (a.s.s = {
                w: o,
                A: a
            });
        }
        Gn(n, r, t + Yn, e, u, i);
    }
    function In(n, r, t, e, u) {
        var i = n[t];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var a = [];
                return Qn(e, i.z, a, u), void Bn(r, 9, u, {
                    w: a,
                    A: i
                });
            }
            In(n, r, t + Yn, e, u);
        } else {
            var o = Bn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function Vn(n, r, t, e) {
        Xn(n, r, t, 0, 0, r.b, e);
    }
    function Xn(n, r, t, e, u, i, a) {
        for(var o = t[e], f = o.r; f === u;){
            var c = o.$;
            if (1 === c) Vn(n, r.k, o.s, a);
            else if (8 === c) o.t = n, o.u = a, (s = o.s.w).length > 0 && Xn(n, r, s, 0, u, i, a);
            else if (9 === c) {
                o.t = n, o.u = a;
                var s, v = o.s;
                v && (v.A.s = n, (s = v.w).length > 0 && Xn(n, r, s, 0, u, i, a));
            } else o.t = n, o.u = a;
            if (!(o = t[++e]) || (f = o.r) > i) return e;
        }
        var b = r.$;
        if (4 === b) {
            for(var l = r.k; 4 === l.$;)l = l.k;
            return Xn(n, l, t, e, u + 1, i, n.elm_event_node_ref);
        }
        for(var d = r.e, h = n.childNodes, g = 0; d.length > g; g++){
            u++;
            var $ = 1 === b ? d[g] : d[g].b, p = u + ($.b || 0);
            if (!(u > f || f > p || (o = t[e = Xn(h[g], $, t, e, u, p, a)]) && (f = o.r) <= i)) return e;
            u = p;
        }
        return e;
    }
    function Zn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, i = Jn(u, e);
            u === n && (n = i);
        }
        return n;
    }
    function Jn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = Fn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return Ln(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return Zn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var i = (t = r.s).e, a = n.childNodes[e = t.v]; i.length > e; e++)n.insertBefore(Fn(i[e], r.u), a);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var o = t.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = Zn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = mn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                wn(t, 2 === u.c ? u.s : Fn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = Zn(n, t.w);
                    for(var u = t.x, i = 0; u.length > i; i++){
                        var a = u[i], o = a.A, f = 2 === o.c ? o.s : Fn(o.z, r.u);
                        n.insertBefore(f, n.childNodes[a.r]);
                    }
                    return e && wn(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                u(10);
        }
    }
    function Un(n) {
        if (3 === n.nodeType) return xn(n.textContent);
        if (1 !== n.nodeType) return xn("");
        for(var r = l, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = d(A2(En, u.name, u.value), r);
        }
        var i = n.tagName.toLowerCase(), a = l, o = n.childNodes;
        for(e = o.length; e--;)a = d(Un(o[e]), a);
        return A3(yn, i, r, a);
    }
    var Kn = F4(function(n, r, t, e) {
        return function(n, r, t, e, i, a) {
            var o = A2(M, n, r ? r.flags : void 0);
            Kr(o) || u(2);
            var f = {}, c = t(o.a), s = c.a, v = a(l, s), b = function(n, r) {
                var t;
                for(var e in on){
                    var u = on[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = cn(u, r);
                }
                return t;
            }(f, l);
            function l(n, r) {
                var t = A2(e, n, s);
                v(s = t.a, r), gn(f, t.b, i(s));
            }
            return gn(f, c.b, i(s)), b ? {
                ports: b
            } : {};
        }(r, e, n.a_, n.bc, n.ba, function(r, t) {
            var u = n.bd, i = e.node, a = Un(i);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (rr(e), r(n), 1);
                }
                return function(u, i) {
                    n = u, i ? (r(n), 2 === t && (t = 1)) : (0 === t && rr(e), t = 2);
                };
            }(t, function(n) {
                var t = u(n), e = function(n, r) {
                    var t = [];
                    return Qn(n, r, t, 0), t;
                }(a, t);
                i = function(n, r, t, e) {
                    return 0 === t.length ? n : (Vn(n, r, t, e), Zn(n, t));
                }(i, a, e, r), a = t;
            });
        });
    }), nr = "undefined" != typeof cancelAnimationFrame ? cancelAnimationFrame : function(n) {
        clearTimeout(n);
    }, rr = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    };
    var tr = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, er = "undefined" != typeof document ? document : tr, ur = "undefined" != typeof window ? window : tr, ir = F3(function(n, r, t) {
        return K(V(function() {
            function e(n) {
                U(t(n));
            }
            return n.addEventListener(r, e, kn && {
                passive: !0
            }), function() {
                n.removeEventListener(r, e);
            };
        }));
    }), ar = F2(function(n, r) {
        var t = B(n, r);
        return Kr(t) ? kr(t.a) : Ar;
    });
    var or = F2(function(n, r) {
        return function(n, r) {
            return V(function(t) {
                rr(function() {
                    var e = document.getElementById(n);
                    t(e ? I(r(e)) : {
                        $: 1,
                        a: at(n)
                    });
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    });
    var fr = F2(function(n, r) {
        var t = "g";
        n.a0 && (t += "m"), n.aN && (t += "i");
        try {
            return kr(RegExp(r, t));
        } catch (n) {
            return Ar;
        }
    }), cr = F4(function(n, r, t, e) {
        var u = 0;
        return e.replace(r, function(r) {
            if (u++ >= n) return r;
            for(var e = arguments.length - 3, i = Array(e); e > 0;){
                var a = arguments[e];
                i[--e] = a ? kr(a) : Ar;
            }
            return t(A4(Ve, r, arguments[arguments.length - 2], u, g(i)));
        });
    }), sr = h, vr = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, i = A3(n, t.b, t.c, A3(vr, n, r, t.e));
            n = u, r = i, t = e;
        }
    }), br = function(n) {
        return A3(vr, F3(function(n, r, t) {
            return A2(sr, c(n, r), t);
        }), l, n);
    }, lr = 1, dr = 2, hr = 0, gr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, $r = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), pr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), mr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), wr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, xr = function(n) {
        return {
            $: 2,
            a: n
        };
    }, yr = w, kr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ar = {
        $: 1
    }, jr = N, _r = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, i = A2(n, t.a, r);
            n = u, r = i, t = e;
        }
    }), Er = function(n) {
        return A3(_r, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, Nr = p, zr = F3(function(n, r, t) {
        for(;;){
            if (o(n, r) >= 1) return t;
            var e = n, u = r - 1, i = A2(sr, r, t);
            n = e, r = u, t = i;
        }
    }), Hr = F2(function(n, r) {
        return A3(zr, n, r, l);
    }), Fr = F2(function(n, r) {
        return A3(Nr, n, A2(Hr, 0, Er(r) - 1), r);
    }), Lr = function(n) {
        return A3(_r, sr, l, n);
    }, Wr = 32, Tr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), Cr = [], Pr = y, Or = F2(function(n, r) {
        return A(r) / A(n);
    }), Mr = function(n) {
        return n;
    }, Br = Pr(A2(Or, 2, Wr)), Qr = A4(Tr, 0, Br, Cr, Cr), Sr = t, Rr = k, qr = function(n) {
        return n.length;
    }, Dr = F2(function(n, r) {
        return o(n, r) > 0 ? n : r;
    }), Yr = x, Gr = e, Ir = F2(function(n, r) {
        for(;;){
            var t = A2(Gr, Wr, n), e = t.b, u = A2(sr, {
                $: 0,
                a: t.a
            }, r);
            if (!e.b) return Lr(u);
            n = e, r = u;
        }
    }), Vr = function(n) {
        return n.a;
    }, Xr = F2(function(n, r) {
        for(;;){
            var t = Pr(r / Wr);
            if (1 === t) return A2(Gr, Wr, n).a;
            n = A2(Ir, n, l), r = t;
        }
    }), Zr = F2(function(n, r) {
        if (r.a) {
            var t = r.a * Wr, e = Rr(A2(Or, Wr, t - 1)), u = n ? Lr(r.d) : r.d, i = A2(Xr, u, r.a);
            return A4(Tr, qr(r.c) + t, A2(Dr, 5, e * Br), i, r.c);
        }
        return A4(Tr, qr(r.c), Br, Cr, r.c);
    }), Jr = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(Zr, !1, {
                d: e,
                a: t / Wr | 0,
                c: u
            });
            var i = {
                $: 1,
                a: A3(Sr, Wr, r, n)
            };
            r -= Wr, e = A2(sr, i, e);
        }
    }), Ur = F2(function(n, r) {
        if (n > 0) {
            var t = n % Wr;
            return A5(Jr, r, n - t - Wr, n, l, A3(Sr, t, n - t, r));
        }
        return Qr;
    }), Kr = function(n) {
        return !n.$;
    }, nt = C, rt = P, tt = O, et = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ut = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, it = function(n) {
        return n;
    }, at = it, ot = E, ft = F2(function(n, r) {
        return 1 > n ? "" : A3(ot, 0, n, r);
    }), ct = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var i = n.charCodeAt(u);
            if (48 > i || i > 57) return Ar;
            r = 10 * r + i - 48;
        }
        return u == e ? Ar : kr(45 == t ? -r : r);
    }, st = I, vt = st(0), bt = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, i = e.b;
            if (i.b) {
                var a = i.a, o = i.b;
                if (o.b) {
                    var f = o.a, c = o.b;
                    if (c.b) {
                        var s = c.b;
                        return A2(n, u, A2(n, a, A2(n, f, A2(n, c.a, t > 500 ? A3(_r, n, r, Lr(s)) : A4(bt, n, r, t + 1, s)))));
                    }
                    return A2(n, u, A2(n, a, A2(n, f, r)));
                }
                return A2(n, u, A2(n, a, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), lt = F3(function(n, r, t) {
        return A4(bt, n, r, 0, t);
    }), dt = F2(function(n, r) {
        return A3(lt, F2(function(r, t) {
            return A2(sr, n(r), t);
        }), l, r);
    }), ht = X, gt = F2(function(n, r) {
        return A2(ht, function(r) {
            return st(n(r));
        }, r);
    }), $t = F3(function(n, r, t) {
        return A2(ht, function(r) {
            return A2(ht, function(t) {
                return st(A2(n, r, t));
            }, t);
        }, r);
    }), pt = function(n) {
        return A3(lt, $t(sr), st(l), n);
    }, mt = sn, wt = F2(function(n, r) {
        var t = r;
        return K(A2(ht, mt(n), t));
    });
    on.Task = fn(vt, F3(function(n, r) {
        return A2(gt, function() {
            return 0;
        }, pt(A2(dt, wt(n), r)));
    }), F3(function() {
        return st(0);
    }), F2(function(n, r) {
        return A2(gt, n, r);
    }));
    var xt, yt = bn("Task"), kt = F2(function(n, r) {
        return yt(A2(gt, n, r));
    }), At = Kn, jt = W, _t = {
        $: 0
    }, Et = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Nt = {
        $: 0
    }, zt = {
        $: 0
    }, Ht = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Ft = F2(function(n, r) {
        var t = r.$ ? r.b : r.a;
        return A2(Ht, c(n.a, n.b), t);
    }), Lt = Yr(1e6), Wt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Tt = function(n) {
        return n.b ? kr(A3(_r, Dr, n.a, n.b)) : Ar;
    }, Ct = F3(function(n, r, t) {
        return r(n(t));
    }), Pt = function(n) {
        return A2(Ct, Mr, A2(Ct, function(n) {
            return n / 1e6;
        }, n ? Pr : Rr));
    }, Ot = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Mt = {
        $: 0
    }, Bt = {
        $: 1
    }, Qt = {
        $: 2
    }, St = {
        $: 3
    }, Rt = {
        $: 5
    }, qt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Dt = {
        $: 4
    }, Yt = function(n) {
        var r;
        return {
            V: (r = n, r.V),
            H: function() {
                var r, t = function(n) {
                    return n.H;
                }(n);
                switch(t){
                    case "Africa":
                        return qt(Mt);
                    case "Asia":
                        return qt(Bt);
                    case "Europe":
                        return qt(Qt);
                    case "North America":
                        return qt(St);
                    case "South America":
                        return qt(Dt);
                    case "Oceania":
                        return qt(Rt);
                    case "Europe&Asia":
                        return {
                            $: 1,
                            a: c(Bt, Qt)
                        };
                    default:
                        return qt((r = function(n) {
                            return n.H;
                        }(n), {
                            $: 6,
                            a: r
                        }));
                }
            }(),
            k: function(n) {
                return n.k;
            }(n),
            Z: function(n) {
                return n.Z;
            }(n)
        };
    }, Gt = (xt = function() {
        var n, r;
        return {
            aE: (n = er.body, r = er.documentElement, {
                bf: Math.max(n.scrollWidth, n.offsetWidth, r.scrollWidth, r.offsetWidth, r.clientWidth),
                aV: Math.max(n.scrollHeight, n.offsetHeight, r.scrollHeight, r.offsetHeight, r.clientHeight)
            }),
            be: {
                aI: ur.pageXOffset,
                aJ: ur.pageYOffset,
                bf: er.documentElement.clientWidth,
                aV: er.documentElement.clientHeight
            }
        };
    }, V(function(n) {
        rr(function() {
            n(I(xt()));
        });
    })), It = F2(function(n, r) {
        return c(n, r);
    }), Vt = H, Xt = L, Zt = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Jt = function(n) {
        return {
            $: 7,
            a: n
        };
    }, Ut = ln, Kt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, ne = F3(function(n, r, t) {
        return {
            ac: t,
            aD: r,
            aF: n
        };
    }), re = st(A3(ne, l, Ar, 0)), te = function(n) {
        return V(function(r) {
            var t = n.f;
            2 === t.$ && t.c && t.c(), n.f = null, r(I(0));
        });
    }, ee = V(function(n) {
        n(I(Date.now()));
    }), ue = V(function(n) {
        var r = rr(function() {
            n(I(Date.now()));
        });
        return function() {
            nr(r);
        };
    }), ie = vn, ae = K, oe = F3(function(n, r, t) {
        var e = t.aD, u = t.ac, i = c(e, r);
        return 1 === i.a.$ ? i.b.b ? A2(ht, function(n) {
            return A2(ht, function(t) {
                return st(A3(ne, r, kr(n), t));
            }, ee);
        }, ae(A2(ht, ie(n), ue))) : re : i.b.b ? st(A3(ne, r, e, u)) : A2(ht, function() {
            return re;
        }, te(i.a.a));
    }), fe = it, ce = F3(function(n, r, t) {
        var e = t.aF, u = t.ac, i = function(t) {
            return A2(mt, n, (0, t.a)(t.$ ? r - u : fe(r)));
        };
        return A2(ht, function(n) {
            return A2(ht, function() {
                return st(A3(ne, e, kr(n), r));
            }, pt(A2(dt, i, e)));
        }, ae(A2(ht, ie(n), ue)));
    }), se = F3(function(n, r, t) {
        return n(r(t));
    });
    on["Browser.AnimationManager"] = fn(re, oe, ce, 0, F2(function(n, r) {
        return r.$ ? Kt(A2(se, n, r.a)) : {
            $: 0,
            a: A2(se, n, r.a)
        };
    }));
    var ve = bn("Browser.AnimationManager"), be = F3(function(n, r, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t
        };
    }), le = F2(function(n, r) {
        return {
            aw: r,
            aF: n
        };
    }), de = {
        $: -2
    }, he = de, ge = st(A2(le, l, he)), $e = function(n) {
        return c(b(n.a ? "w_" : "d_", n.b), n);
    }, pe = F5(function(n, r, t, e, u) {
        return {
            $: -1,
            a: n,
            b: r,
            c: t,
            d: e,
            e: u
        };
    }), me = F5(function(n, r, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(pe, n, r, t, e, u);
            var i = e.d;
            return a = e.e, A5(pe, 0, e.b, e.c, A5(pe, 1, i.b, i.c, i.d, i.e), A5(pe, 1, r, t, a, u));
        }
        var a, o = u.b, f = u.c, c = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(pe, n, o, f, A5(pe, 0, r, t, e, c), s) : A5(pe, 0, r, t, A5(pe, 1, e.b, e.c, e.d, a = e.e), A5(pe, 1, o, f, c, s));
    }), we = f, xe = F3(function(n, r, t) {
        if (-2 === t.$) return A5(pe, 0, n, r, de, de);
        var e = t.a, u = t.b, i = t.c, a = t.d, o = t.e;
        switch(A2(we, n, u)){
            case 0:
                return A5(me, e, u, i, A3(xe, n, r, a), o);
            case 1:
                return A5(pe, e, u, r, a, o);
            default:
                return A5(me, e, u, i, a, A3(xe, n, r, o));
        }
    }), ye = F3(function(n, r, t) {
        var e = A3(xe, n, r, t);
        return -1 !== e.$ || e.a ? e : A5(pe, 1, e.b, e.c, e.d, e.e);
    }), ke = function(n) {
        return A3(_r, F2(function(n, r) {
            return A3(ye, n.a, n.b, r);
        }), he, n);
    }, Ae = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.e, u = n, i = A3(n, t.b, t.c, A3(Ae, n, r, t.d));
            n = u, r = i, t = e;
        }
    }), je = F6(function(n, r, t, e, u, i) {
        var a = A3(Ae, F3(function(e, u, i) {
            n: for(;;){
                var a = i.a, f = i.b;
                if (a.b) {
                    var s = a.a, v = s.a, b = s.b, l = a.b;
                    if (0 > o(v, e)) {
                        i = c(l, A3(n, v, b, f));
                        continue n;
                    }
                    return o(v, e) > 0 ? c(a, A3(t, e, u, f)) : c(l, A4(r, v, b, u, f));
                }
                return c(a, A3(t, e, u, f));
            }
        }), c(br(e), i), u), f = a.a, s = a.b;
        return A3(_r, F2(function(r, t) {
            return A3(n, r.a, r.b, t);
        }), s, f);
    }), _e = F2(function(n, r) {
        return {
            an: r,
            as: n
        };
    }), Ee = F3(function(n, r, t) {
        return A2(gt, function(n) {
            return c(r, n);
        }, A3(ir, t.a ? ur : er, t.b, function(t) {
            return A2(ie, n, A2(_e, r, t));
        }));
    }), Ne = F2(function(n, r) {
        return A3(Ae, ye, r, n);
    }), ze = F3(function(n, r, t) {
        var e = F3(function(r, t, e) {
            var u = e.c;
            return s(e.a, e.b, A2(sr, A3(Ee, n, r, t), u));
        }), u = F3(function(n, r, t) {
            var e = t.b, u = t.c;
            return s(A2(sr, r, t.a), e, u);
        }), i = F4(function(n, r, t, e) {
            var u = e.c;
            return s(e.a, A3(ye, n, r, e.b), u);
        }), a = A2(dt, $e, r), o = A6(je, u, i, e, t.aw, ke(a), s(l, he, l)), f = o.b, c = o.c;
        return A2(ht, function(n) {
            return st(A2(le, a, A2(Ne, f, ke(n))));
        }, A2(ht, function() {
            return pt(c);
        }, pt(A2(dt, te, o.a))));
    }), He = F3(function(n, r, t) {
        var e = n(r);
        return e.$ ? t : A2(sr, e.a, t);
    }), Fe = F2(function(n, r) {
        return A3(lt, He(n), l, r);
    });
    on["Browser.Events"] = fn(ge, ze, F3(function(n, r, t) {
        var e = r.as, u = r.an, a = A2(Fe, function(n) {
            var r = n.b.c;
            return i(n.a, e) ? A2(ar, r, u) : Ar;
        }, t.aF);
        return A2(ht, function() {
            return st(t);
        }, pt(A2(dt, mt(n), a)));
    }), 0, F2(function(n, r) {
        return A3(be, r.a, r.b, A2(rt, n, r.c));
    }));
    var Le, We, Te = bn("Browser.Events"), Ce = F3(function(n, r, t) {
        return Te(A3(be, n, r, t));
    }), Pe = F, Oe = F2(function(n, r) {
        return n(r ? 1 : 0);
    }), Me = function(n) {
        var r = void 0 !== mn.hidden ? {
            aW: "hidden",
            aP: "visibilitychange"
        } : void 0 !== mn.mozHidden ? {
            aW: "mozHidden",
            aP: "mozvisibilitychange"
        } : void 0 !== mn.msHidden ? {
            aW: "msHidden",
            aP: "msvisibilitychange"
        } : void 0 !== mn.webkitHidden ? {
            aW: "webkitHidden",
            aP: "webkitvisibilitychange"
        } : {
            aW: "hidden",
            aP: "visibilitychange"
        };
        return A3(Ce, 0, r.aP, A2(rt, Oe(n), A2(jt, "target", A2(jt, r.aW, Pe))));
    }, Be = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Qe = function(n) {
        return {
            $: 6,
            a: n
        };
    }, Se = {
        $: 0
    }, Re = function(n) {
        return {
            $: 1,
            a: n
        };
    }, qe = function(n) {
        return {
            $: 1,
            a: n
        };
    }, De = Z, Ye = F2(function(n, r) {
        return yt(A2(De, A2(se, A2(se, st, n), gr), A2(ht, A2(se, A2(se, st, n), wr), r)));
    }), Ge = F3(function(n, r, t) {
        return 0 > o(t, n) ? n : o(t, r) > 0 ? r : t;
    }), Ie = F2(function(n, r) {
        var t = r.b;
        return c(n(r.a), t);
    }), Ve = F4(function(n, r, t, e) {
        return {
            aZ: r,
            a$: n,
            a1: t,
            a9: e
        };
    }), Xe = fr, Ze = A2(Ct, function(n) {
        return A2(Xe, {
            aN: !1,
            a0: !1
        }, n);
    }, Ot(/.^/)), Je = (Le = g([
        c("[\xe0-\xe6]", "a"),
        c("[\xc0-\xc6]", "A"),
        c("\xe7", "c"),
        c("\xc7", "C"),
        c("[\xe8-\xeb]", "e"),
        c("[\xc8-\xcb]", "E"),
        c("[\xec-\xef]", "i"),
        c("[\xcc-\xcf]", "I"),
        c("\xf1", "n"),
        c("\xd1", "N"),
        c("[\xf2-\xf6]", "o"),
        c("[\xd2-\xd6]", "O"),
        c("[\xf9-\xfc]", "u"),
        c("[\xd9-\xdc]", "U"),
        c("\xfd", "y"),
        c("\xff", "y"),
        c("\xdd", "Y")
    ]), A2(dt, Ie(Ze), Le)), Ue = cr(1 / 0), Ke = function(n) {
        return function(n) {
            return "" === n;
        }(n) ? n : A3(_r, function(n) {
            var r = n.b;
            return A2(Ue, n.a, function() {
                return r;
            });
        }, n, Je);
    }, nu = function(n) {
        return n.toLowerCase();
    }, ru = F2(function(n, r) {
        return i(Ke(nu(n)), Ke(nu(r)));
    }), tu = g([
        {
            n: Mt,
            k: "Africa"
        },
        {
            n: Bt,
            k: "Asia"
        },
        {
            n: Qt,
            k: "Europe"
        },
        {
            n: St,
            k: "North America"
        },
        {
            n: Dt,
            k: "South America"
        },
        {
            n: Rt,
            k: "Oceania"
        }
    ]), eu = F2(function(n, r) {
        return A3(lt, F2(function(r, t) {
            return n(r) ? A2(sr, r, t) : t;
        }), l, r);
    }), uu = F2(function(n, r) {
        var t = n.H;
        if (t.$) {
            var e = t.a, u = e.b;
            return i(r.n, e.a) || i(r.n, u);
        }
        return i(r.n, t.a);
    }), iu = F2(function(n, r) {
        if (r.$) {
            var t = r.b;
            return u = t.a, o(t.b, n) > -1 && o(n, u) > -1;
        }
        var e = r.a, u = e.a;
        return o(e.b, n) > -1 && o(n, u) > -1;
    }), au = F2(function(n, r) {
        var t = n.W, e = n.l;
        return A2(eu, function(n) {
            return !t.$ || A2(uu, n, t.a);
        }, A2(eu, function(n) {
            return A2(iu, n.Z, e);
        }, r));
    }), ou = or("focus"), fu = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), cu = function(n) {
        var r = n.b;
        return A2(fu, 1664525 * n.a + r >>> 0, r);
    }, su = (We = fe, V(function(n) {
        n(I(We(Date.now())));
    })), vu = A2(ht, function(n) {
        var r, t;
        return st((r = n, t = cu(A2(fu, 0, 1013904223)), cu(A2(fu, t.a + r >>> 0, t.b))));
    }, su), bu = F2(function(n, r) {
        return n(r);
    }), lu = F3(function(n, r, t) {
        if (r.b) {
            var e = r.b, u = A2(bu, r.a, t), i = u.b;
            return A2(ht, function() {
                return A3(lu, n, e, i);
            }, A2(mt, n, u.a));
        }
        return st(t);
    }), du = F3(function(n, r, t) {
        return st(t);
    }), hu = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), u = e.b;
            return c(n(e.a), u);
        };
    });
    on.Random = fn(vu, lu, du, F2(function(n, r) {
        return A2(hu, n, r);
    }));
    var gu, $u, pu = bn("Random"), mu = F2(function(n, r) {
        return pu(A2(hu, n, r));
    }), wu = {
        $: 0
    }, xu = function(n) {
        return {
            $: 1,
            a: n
        };
    }, yu = A2(Ct, eu(function(n) {
        switch(n.$){
            case 0:
            case 1:
                return !0;
            default:
                return !1;
        }
    }), Er), ku = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var t = r.b;
            if (n(r.a)) return !0;
            r = t;
        }
    }), Au = function(n) {
        return !n;
    }, ju = F2(function(n, r) {
        return !A2(ku, A2(se, Au, n), r);
    })(function(n) {
        return !n.$;
    }), _u = A2(Ct, eu(function(n) {
        switch(n.$){
            case 3:
            case 5:
            case 2:
                return !0;
            default:
                return !1;
        }
    }), Er), Eu = function(n) {
        return !_u(n);
    }, Nu = function(n) {
        return {
            $: 5,
            a: n
        };
    }, zu = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Hu = function(n) {
        return n.b ? kr(n.a) : Ar;
    }, Fu = F2(function(n, r) {
        return 0 > n ? Ar : Hu(A2(zu, n, r));
    }), Lu = function(n) {
        return n.b;
    }, Wu = function(n) {
        return function(r) {
            switch(r.$){
                case 0:
                case 1:
                case 3:
                default:
                    return r.a;
                case 2:
                    return t = r.a, n ? t.b : t.a;
                case 4:
                    var t;
                    return (t = r.a).a;
            }
        };
    }, Tu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cu = F3(function(n, r, t) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    var e = r.a;
                    n -= 1, r = r.b, t = A2(sr, e, t);
                    continue n;
                }
                return t;
            }
            return t;
        }
    }), Pu = F2(function(n, r) {
        return Lr(A3(Cu, n, r, l));
    }), Ou = F3(function(n, r, t) {
        if (r > 0) {
            var e = c(r, t);
            n: for(;;){
                r: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break n;
                        break r;
                    }
                    switch(e.a){
                        case 1:
                            break n;
                        case 2:
                            var u = e.b;
                            return g([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var i = e.b, a = i.b;
                                return g([
                                    i.a,
                                    a.a,
                                    a.b.a
                                ]);
                            }
                            break r;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var o = e.b, f = o.b, s = f.b, v = s.b, b = v.b;
                                return A2(sr, o.a, A2(sr, f.a, A2(sr, s.a, A2(sr, v.a, n > 1e3 ? A2(Pu, r - 4, b) : A3(Ou, n + 1, r - 4, b)))));
                            }
                            break r;
                    }
                }
                return t;
            }
            return g([
                e.b.a
            ]);
        }
        return l;
    }), Mu = F2(function(n, r) {
        return A3(Ou, 0, n, r);
    }), Bu = F2(function(n, r) {
        return Lr(A2(Mu, n, Lr(r)));
    }), Qu = F2(function(n, r) {
        return b(n, A2(Bu, Er(r) - Er(n), r));
    }), Su = F2(function(n, r) {
        return 1 > n ? r : A3(ot, 0, -n, r);
    }), Ru = F2(function(n, r) {
        for(;;){
            if (i(n, "")) return n;
            if (A2(ru, n, A2(ft, n.length, r))) return n;
            n = A2(Su, 1, n);
        }
    }), qu = _, Du = function(n) {
        return A3(qu, sr, l, n);
    }, Yu = function(n) {
        return $(n).join("");
    }, Gu = A2(Ct, dt(Wu(!1)), Yu), Iu = F2(function(n, r) {
        var t = A3(Nr, F2(function(n) {
            switch(n.$){
                case 5:
                    return Tu(n.a);
                case 3:
                    return {
                        $: 1,
                        a: n.a
                    };
                case 4:
                case 2:
                    return Tu(n.a.a);
                default:
                    return n;
            }
        }), r, Du(A2(Ru, n, Gu(r))));
        return A2(Qu, t, r);
    }), Vu = F2(function(n, r) {
        var t = A2(Iu, n, r);
        return A2(Fr, F2(function(r, t) {
            if (function(n) {
                switch(n.$){
                    case 0:
                    case 1:
                        return !0;
                    default:
                        return !1;
                }
            }(t)) return t;
            if (function(n) {
                switch(n.$){
                    case 3:
                    case 1:
                        return !0;
                    default:
                        return !1;
                }
            }(t)) return t;
            var e = A2(Fu, r, Du(n));
            if (1 === e.$) return function(n) {
                switch(n.$){
                    case 4:
                    case 3:
                        return !0;
                    default:
                        return !1;
                }
            }(t) ? t : Nu(A2(Wu, !1, t));
            var u = e.a;
            return {
                $: 2,
                a: c(A2(Wu, !1, t), u)
            };
        }), t);
    }), Xu = function(n) {
        return v(n, {
            M: 0
        });
    }, Zu = A2(Ct, Du, dt(function(n) {
        return i(" ", n) ? {
            $: 4,
            a: c(" ", Ar)
        } : Nu(n);
    })), Ju = F2(function(n, r) {
        var t = r.o;
        if (1 === t.$) return r;
        var e, u = t.a, i = u.w, a = A2(Vu, n, i), f = v(r, {
            m: o(yu(a), yu(i)) > 0 ? Xu(r.m) : r.m
        });
        if (Eu(a)) {
            var c = r.N;
            if (c.b) {
                var s = c.a, b = c.b;
                return v(f, {
                    r: A2(sr, {
                        f: u.f,
                        Q: ju(a) ? wu : xu(a)
                    }, r.r),
                    N: b,
                    o: kr({
                        w: Zu((e = s, e.k)),
                        f: s
                    })
                });
            }
            return v(f, {
                r: Lr(A2(sr, {
                    f: u.f,
                    Q: ju(a) ? wu : xu(a)
                }, r.r)),
                o: Ar
            });
        }
        return v(f, {
            o: kr(v(u, {
                w: A2(Vu, n, i)
            }))
        });
    }), Uu = F2(function(n, r) {
        if (n.b) {
            var t = n.a;
            return {
                r: l,
                N: n.b,
                m: r,
                o: kr({
                    w: Zu((e = t, e.k)),
                    f: t
                })
            };
        }
        var e;
        return {
            r: l,
            N: l,
            m: r,
            o: Ar
        };
    }), Ku = F2(function(n, r) {
        var t, e;
        return n.$ ? (e = (t = r).m, A2(Uu, A2(dt, function(n) {
            return n.f;
        }, A2(eu, function(n) {
            return !i(n.Q, wu);
        }, t.r)), Xu(e))) : A2(Ju, n.a, r);
    }), ni = F2(function(n, r) {
        return r.$ ? Ar : kr(n(r.a));
    }), ri = F3(function(n, r, t) {
        return 1 === r.$ || 1 === t.$ ? Ar : kr(A2(n, r.a, t.a));
    }), ti = ln(l), ei = F2(function(n, r) {
        if (r.$) {
            var t = r.a, e = t.a, u = t.b;
            return i = r.b.a, A2(Ht, c(e, u), c(i, A3(Ge, e, u, n)));
        }
        var i;
        return Wt(c(i = r.a.a, n));
    }), ui = F2(function(n, r) {
        if (r.$) {
            var t = r.a, e = t.a, u = t.b;
            return i = r.b.b, A2(Ht, c(e, u), c(A3(Ge, e, u, n), i));
        }
        var i;
        return Wt(c(n, i = r.a.b));
    }), ii = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> 4 + (r >>> 28));
        return (t >>> 22 ^ t) >>> 0;
    }, ai = F2(function(n, r) {
        return function(t) {
            var e = 0 > o(n, r) ? c(n, r) : c(r, n), u = e.a, i = e.b - u + 1;
            if (i - 1 & i) {
                var a = (-i >>> 0) % i >>> 0;
                return function(n) {
                    for(;;){
                        var r = ii(n), t = cu(n);
                        if (o(r, a) >= 0) return c(r % i + u, t);
                        n = t;
                    }
                }(t);
            }
            return c(((i - 1 & ii(t)) >>> 0) + u, cu(t));
        };
    }), oi = A2(ai, -2147483648, 2147483647), fi = F4(function(n, r, t, e) {
        var u = r, i = t, a = e;
        return function(r) {
            var t = u(r), e = t.a, o = i(t.b), f = o.a, s = a(o.b), v = s.b;
            return c(A3(n, e, f, s.a), v);
        };
    }), ci = function(n) {
        var r = F3(function(n, r, t) {
            return cu(A2(fu, n, (1 | r ^ t) >>> 0));
        }), t = A2(ai, 0, 4294967295);
        return A2(bu, A4(fi, r, t, t, t), n);
    }, si = m, vi = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return Ar;
            var e = t.b;
            if (r(t.a)) return kr(n);
            n += 1, t = e;
        }
    })(0), bi = function(n) {
        switch(n.$){
            case 0:
            case 1:
            case 3:
            case 4:
                return !0;
            default:
                return !1;
        }
    }, li = function(n) {
        var r = A2(vi, A2(se, Au, bi), n);
        if (1 === r.$) return n;
        var t = r.a;
        return A2(Fr, F2(function(n, r) {
            return o(t, n) > 0 ? r : i(n, t) ? {
                $: 3,
                a: A2(Wu, !1, r)
            } : 4 === r.$ ? r : Nu(A2(Wu, !1, r));
        }), n);
    }, di = F2(function(n, r) {
        var t = r, e = t.ah, u = t.M;
        if (1 === t.Q) return c(r, !1);
        var i = n + u, a = o(e, i) > 0 ? c(i, !1) : c(i - e, !0), f = a.b;
        return c(v(t, {
            M: a.a
        }), f);
    }), hi = F2(function(n, r) {
        var t, e;
        return e = (t = A2(di, n, r.m)).a, t.b ? function(n) {
            var r = n.o;
            if (1 === r.$) return n;
            var t = r.a.f;
            return v(n, {
                o: kr({
                    w: li(r.a.w),
                    f: t
                })
            });
        }(v(r, {
            m: e
        })) : v(r, {
            m: e
        });
    }), gi = F2(function(n, r) {
        var t, e, u = r.t, i = r.G, a = r.X, o = r.P, f = c(r, ti);
        switch(n.$){
            case 0:
            case 2:
                return f;
            case 1:
                var s = n.a, b = s.a, d = s.b;
                return c(v(r, i.$ ? {
                    G: Re(v(i.a, {
                        Y: {
                            ap: d,
                            aH: b
                        }
                    }))
                } : {
                    G: Re({
                        Y: {
                            ap: d,
                            aH: b
                        },
                        ar: !1
                    })
                }), ti);
            case 3:
                var h = n.a, g = n.b, $ = function() {
                    switch(h){
                        case 0:
                            return v(o, {
                                x: A2(Ot, o.x, A2(ni, Mr, A3(ri, Yr, kr(1e3), A2(ni, A2(Ge, 2, 30), ct(g)))))
                            });
                        case 1:
                            return v(o, {
                                A: A2(Ot, o.A, A2(ni, A2(Ge, 1, Er(A2(au, o, a))), ct(g)))
                            });
                        case 2:
                            var n = Hu(A2(eu, function(n) {
                                return A2(ru, n.k, g);
                            }, tu));
                            return v(o, {
                                W: A2(Ot, _t, A2(ni, Be, n))
                            });
                        case 3:
                            return v(o, {
                                l: A2(ui, Lt(A2(Ot, 0, ct(g))), o.l)
                            });
                        default:
                            return v(o, {
                                l: A2(ei, Lt(A2(Ot, 0, ct(g))), o.l)
                            });
                    }
                }();
                return c(v(r, {
                    P: $
                }), ti);
            case 4:
                return c(v(r, {
                    t: zt
                }), ti);
            case 5:
                return c(r, A2(mu, Qe, (e = a, A2(hu, function(n) {
                    return A2(dt, Vr, A2(si, Lu, A3(_r, F2(function(n, r) {
                        var t = r.a, e = A2(bu, oi, r.b), u = e.b;
                        return c(A2(sr, c(n, e.a), t), u);
                    }), c(l, n), e).a));
                }, ci))));
            case 6:
                return c(v(r, {
                    t: qe(A2(Uu, A2(dt, function(n) {
                        var r, t;
                        return {
                            aX: (t = n.V, "country-flags/" + nu(t) + ".svg"),
                            k: (r = n, r.k)
                        };
                    }, A2(Mu, o.A, A2(au, o, n.a))), (t = o.x, {
                        M: 0,
                        Q: 0,
                        ah: t
                    })))
                }), A2(Ye, function() {
                    return Se;
                }, ou("guess-input")));
            case 7:
                return u.$ ? c(v(r, {
                    t: qe(A2(hi, n.a, u.a))
                }), ti) : f;
            default:
                return u.$ ? c(v(r, {
                    t: qe(A2(Ku, n.a, u.a))
                }), ti) : f;
        }
    }), $i = {
        a7: {
            aS: function(n) {
                return {
                    $: 8,
                    a: n
                };
            },
            a6: {
                $: 4
            }
        }
    }, pi = xn, mi = function(n) {
        return {
            $: 0,
            a: n
        };
    }, wi = {
        $: 1
    }, xi = yn("button"), yi = A2(Ct, eu(function(n) {
        switch(n.$){
            case 1:
            case 3:
                return !0;
            default:
                return !1;
        }
    }), Er), ki = yn("div"), Ai = yn("h1"), ji = yn("img"), _i = pi(""), Ei = An, Ni = F2(function(n, r) {
        return A2(Ei, n, {
            $: 0,
            a: r
        });
    }), zi = function(n) {
        return A2(Ni, "click", et(n));
    }, Hi = yn("span"), Fi = G, Li = F2(function(n, r) {
        return A2(_n, n, Fi(r));
    }), Wi = function(n) {
        var r;
        return A2(Li, "src", Nn.test(r = n) ? "" : r);
    }, Ti = jn, Ci = function(n) {
        return A2(Li, "autocomplete", n ? "on" : "off");
    }, Pi = Li("className"), Oi = Li("id"), Mi = yn("input"), Bi = A2(Ct, eu(function(n) {
        switch(n.$){
            case 0:
            case 1:
            case 2:
                return !0;
            default:
                return !1;
        }
    }), Er), Qi = Er, Si = function(n) {
        return i(Qi(n), Bi(n)) && !Eu(n);
    }, Ri = function(n) {
        return c(n, !0);
    }, qi = F2(function(n, r) {
        return A2(Ei, n, {
            $: 1,
            a: r
        });
    }), Di = A2(F2(function(n, r) {
        return A3(lt, jt, r, n);
    }), g([
        "target",
        "value"
    ]), Xt), Yi = function(n) {
        return A2(qi, "input", A2(rt, Ri, A2(rt, n, Di)));
    }, Gi = A2(Ct, jr, function(n) {
        return n + "px";
    }), Ii = F2(function(n, r) {
        return Rr(r * (n > 600 ? 1 : n > 500 ? 2 / 3 : .5));
    }), Vi = G, Xi = F2(function(n, r) {
        return A2(_n, n, Vi(r));
    })("spellcheck"), Zi = F2(function(n, r) {
        return Yu(A2(dt, function(r) {
            switch(r.$){
                case 0:
                case 1:
                case 2:
                    return " ";
                case 3:
                    return r.a;
                case 5:
                    return n;
                default:
                    return r.a.a;
            }
        }, r));
    }), Ji = A2(Ct, Fe(function(n) {
        switch(n.$){
            case 0:
            case 1:
                return kr(n.a);
            case 2:
                return kr(n.a.b);
            default:
                return Ar;
        }
    }), Yu), Ui = A2(Ti, "background-color", "rgba(0,0,0,0.0)"), Ki = Li("value"), na = F4(function(n, r, t, e) {
        var u = A2(Ii, r, 55), i = u / 2 | 0, a = (r / 2 | 0) - (Rr(u / 1.65) * Qi(t) / 2 | 0);
        return A2(ki, g([
            A2(Ti, "position", "absolute"),
            A2(Ti, "width", "100%"),
            A2(Ti, "bottom", "0"),
            A2(Ti, "overflow", "hidden"),
            Si(t) ? Pi("animate-background-grey-red") : A2(Ti, "background-color", "rgba(34,34,34,0.5)")
        ]), g([
            A2(Mi, g([
                Oi("guess-hints"),
                Ci(!1),
                Xi(!1),
                Ki(A2(Zi, "-", t)),
                A2(Ti, "outline", "0"),
                A2(Ti, "border", "0"),
                A2(Ti, "margin", "0"),
                A2(Ti, "color", "#ccc"),
                Ui,
                A2(Ti, "padding", Gi(i) + " " + Gi(a)),
                A2(Ti, "font-size", Gi(u)),
                Pi("font-mono")
            ]), l),
            A2(Mi, g([
                Oi(n),
                Ci(!1),
                Xi(!1),
                Ki(Ji(t)),
                A2(Ti, "position", "absolute"),
                A2(Ti, "width", "100%"),
                A2(Ti, "top", "0"),
                A2(Ti, "left", "0"),
                A2(Ti, "outline", "0"),
                A2(Ti, "border", "0"),
                A2(Ti, "margin", "0"),
                Ui,
                A2(Ti, "padding", Gi(i) + " " + Gi(a)),
                A2(Ti, "font-size", Gi(u)),
                A2(Ti, "color", "white"),
                Pi("font-mono"),
                Yi(e)
            ]), l)
        ]));
    }), ra = j, ta = function(n) {
        return A2(ra, n, "");
    }, ea = A2(Ct, dt(function(n) {
        if (1 === n.$) {
            var r = n.a;
            return A2(Hi, g([
                A2(Ti, "color", "#ff5f61")
            ]), g([
                pi(ta(r))
            ]));
        }
        return pi(ta(A2(Wu, !1, n)));
    }), ki(l)), ua = function(n) {
        var r = n.f, t = n.Q;
        if (t.$) {
            var e = t.a;
            return A2(ki, g([
                A2(Ti, "color", "#8e8e93"),
                A2(Ti, "font-weight", "bold"),
                A2(Ti, "font-size", "22px"),
                A2(Ti, "align-items", "center"),
                A2(Ti, "display", "flex"),
                A2(Ti, "flex-direction", "column")
            ]), g([
                A2(ji, g([
                    Wi(r.aX),
                    A2(Ti, "object-fit", "fill"),
                    A2(Ti, "width", "300px"),
                    A2(Ti, "height", "200px"),
                    A2(Ti, "max-width", "300px")
                ]), l),
                A2(ki, g([
                    A2(Ti, "text-align", "center")
                ]), g([
                    ea(e)
                ]))
            ]));
        }
        return _i;
    }, ia = F3(function(n, r, t) {
        var e = r.aS, u = r.a6, a = t.o, o = t.r;
        if (a.$) {
            var f = A3(_r, yr, 0, A2(dt, yi, A2(Fe, function(n) {
                var r = n.Q;
                return r.$ ? kr(r.a) : Ar;
            }, o))), c = Er(A2(eu, function(n) {
                return i(n.Q, wu);
            }, o)), s = Er(o), v = !(s - c);
            return A2(ki, g([
                A2(Ti, "min-height", "100%"),
                A2(Ti, "display", "flex"),
                A2(Ti, "flex-direction", "column"),
                A2(Ti, "gap", "40px"),
                A2(Ti, "background-color", "#fff8e7")
            ]), g([
                A2(ki, g([
                    A2(Ti, "color", "#1d3557"),
                    A2(Ti, "text-align", "center"),
                    A2(Ti, "font-size", "22px")
                ]), g([
                    A2(Ai, l, g([
                        pi("Finished")
                    ])),
                    A2(ki, l, g([
                        pi(jr(c)),
                        pi(" of "),
                        pi(jr(s)),
                        pi(" flags guessed correctly. "),
                        A2(Hi, g([
                            A2(Ti, "color", "#ff5f61"),
                            A2(Ti, "font-weight", "bold")
                        ]), g([
                            pi(jr(f))
                        ])),
                        pi(" hints were given.")
                    ]))
                ])),
                A2(ki, g([
                    A2(Ti, "display", "flex"),
                    A2(Ti, "flex-wrap", "wrap"),
                    A2(Ti, "justify-content", "center"),
                    A2(Ti, "gap", "10px")
                ]), A2(dt, ua, o)),
                A2(ki, g([
                    A2(Ti, "display", "flex"),
                    A2(Ti, "gap", "10px"),
                    A2(Ti, "padding", "10px 10px"),
                    A2(Ti, "justify-content", "center")
                ]), g([
                    v ? _i : A2(xi, g([
                        A2(Ti, "width", "400px"),
                        A2(Ti, "height", "60px"),
                        A2(Ti, "font-size", "20px"),
                        A2(Ti, "background-color", "#a8dadc"),
                        zi(e(wi))
                    ]), g([
                        pi("Retry Hinted")
                    ])),
                    A2(xi, g([
                        A2(Ti, "width", "400px"),
                        A2(Ti, "height", "60px"),
                        A2(Ti, "font-size", "20px"),
                        A2(Ti, "color", "white"),
                        A2(Ti, "background-color", "#457b9d"),
                        zi(u)
                    ]), g([
                        pi("Exit Quiz")
                    ]))
                ]))
            ]));
        }
        var b = a.a.f, d = a.a.w;
        return A2(ki, g([
            A2(Ti, "height", "100%"),
            A2(Ti, "background-color", "#fff8e7"),
            A2(Ti, "display", "flex"),
            A2(Ti, "align-items", "center"),
            A2(Ti, "justify-content", "center")
        ]), g([
            A2(ki, g([
                A2(Ti, "display", "flex"),
                A2(Ti, "width", "100%"),
                A2(Ti, "max-width", "1000px"),
                A2(Ti, "padding", "0px 10px 60px")
            ]), g([
                A2(ji, g([
                    Wi(b.aX)
                ]), l)
            ])),
            A4(na, "guess-input", n.aH, d, A2(Ct, mi, e))
        ]));
    }), aa = F3(function(n, r, t) {
        return A3(ia, n, r.a7, t);
    }), oa = {
        $: 5
    }, fa = yn("h2"), ca = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), sa = function(n) {
        return n.$ ? n.b.b : n.a.b;
    }, va = N, ba = yn("option"), la = yn("select"), da = Li("type"), ha = F2(function(n, r) {
        var t, e, u, i, a, o;
        return A2(ki, g([
            A2(Ti, "display", "flex"),
            A2(Ti, "align-items", "center"),
            A2(Ti, "padding", "0px 20px"),
            A2(Ti, "flex-direction", "column"),
            A2(Ti, "justify-content", "center"),
            A2(Ti, "min-height", "100%"),
            A2(Ti, "box-sizing", "border-box"),
            A2(Ti, "background-color", "#fff8e7")
        ]), g([
            A2(ki, g([
                A2(Ti, "max-width", "800px"),
                A2(Ti, "color", "#1d3557")
            ]), g([
                A2(ki, g([
                    A2(Ti, "margin-bottom", "60px")
                ]), g([
                    A2(Ai, g([
                        A2(Ti, "margin-bottom", "0")
                    ]), g([
                        pi("Flag Quiz")
                    ])),
                    A2(fa, g([
                        A2(Ti, "margin-top", "0")
                    ]), g([
                        pi("\u2014 guess the country by its flag")
                    ]))
                ])),
                A2(ki, g([
                    A2(Ti, "display", "flex"),
                    A2(Ti, "flex-direction", "column"),
                    A2(Ti, "gap", "60px")
                ]), g([
                    (t = r, u = t.P, i = t.X, a = function(n) {
                        return Mi(b(g([
                            A2(Ti, "font-size", Gi(20)),
                            A2(Ti, "width", Gi(60)),
                            A2(Ti, "text-align", "center")
                        ]), n));
                    }, o = function(n) {
                        return la(b(g([
                            A2(Ti, "font-size", Gi(20))
                        ]), n));
                    }, A2(ki, g([
                        A2(Ti, "display", "flex"),
                        A2(Ti, "flex-direction", "column"),
                        A2(Ti, "gap", "40px"),
                        A2(Ti, "font-size", Gi(20))
                    ]), g([
                        A2(ki, l, g([
                            pi("You'll be presented with the flag of a random country. Type the country's name. A hint will be given each "),
                            A2(a, g([
                                Pi("input-setting"),
                                da("number"),
                                A2(Ti, "width", "40px"),
                                Ki(va(u.x / 1e3)),
                                Yi(ca(0))
                            ]), l),
                            pi(" seconds after not finding a matching letter.")
                        ])),
                        A2(ki, g([
                            A2(Ti, "display", "flex_"),
                            A2(Ti, "justify-content", "space-between")
                        ]), g([
                            pi("The quiz may include countries from "),
                            A2(o, g([
                                Pi("input-setting"),
                                A2(Ti, "text-align", "center"),
                                Yi(ca(2))
                            ]), A2(sr, A2(ba, g([
                                Ki("all")
                            ]), g([
                                pi("all continents")
                            ])), A2(dt, function(n) {
                                return A2(ba, g([
                                    Ki(n.k)
                                ]), g([
                                    pi(n.k)
                                ]));
                            }, tu))),
                            pi(" where population size is at least "),
                            A2(a, g([
                                Pi("input-setting"),
                                da("number"),
                                A2(Ti, "text-align", "center"),
                                A2(Ti, "width", "65px"),
                                Ki(jr(A2(Pt, !1, (e = u.l, e.$ ? e.b.a : e.a.a)))),
                                Yi(ca(3))
                            ]), l),
                            pi(" million"),
                            pi(" and at most "),
                            A2(a, g([
                                Pi("input-setting"),
                                da("number"),
                                A2(Ti, "text-align", "center"),
                                A2(Ti, "width", "65px"),
                                Ki(jr(A2(Pt, !0, sa(u.l)))),
                                Yi(ca(4))
                            ]), l),
                            pi(" million.")
                        ])),
                        A2(ki, l, g([
                            pi("Pick "),
                            A2(a, g([
                                Pi("input-setting"),
                                A2(Ti, "width", "50px"),
                                da("number"),
                                Ki(jr(u.A)),
                                Yi(ca(1))
                            ]), l),
                            pi(" random flags from "),
                            pi(jr(Er(A2(au, u, i))) + " countries.")
                        ]))
                    ]))),
                    A2(ki, g([
                        A2(Ti, "display", "flex"),
                        A2(Ti, "align-items", "center"),
                        A2(Ti, "justify-content", "center")
                    ]), g([
                        A2(xi, g([
                            A2(Ti, "width", "400px"),
                            A2(Ti, "height", "60px"),
                            A2(Ti, "font-size", "20px"),
                            A2(Ti, "background-color", "#a8dadc"),
                            zi(oa)
                        ]), g([
                            pi("Start Quiz")
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    gu = {
        Main: {
            init: At({
                a_: function(n) {
                    var r = A2(dt, Yt, n._), t = function(n) {
                        var r, t;
                        return A2(Ft, c(0, Lt(A2(Pt, !0, A2(Ot, 0, Tt(r = A2(dt, function(n) {
                            return n.Z;
                        }, n)))))), (t = c(0, A2(Ot, 0, Tt(r))), Wt(c(t.a, t.b))));
                    }(r);
                    return c({
                        G: Nt,
                        X: r,
                        t: zt,
                        P: {
                            W: _t,
                            x: 5e3,
                            l: t,
                            A: 10
                        }
                    }, A2(kt, Et, A2(gt, function(n) {
                        var r = n.be;
                        return A2(It, Rr(r.bf), Rr(r.aV));
                    }, Gt)));
                },
                ba: function(n) {
                    var r, t, e = n.t.$ ? g([
                        (t = Jt, ve(Kt(t)))
                    ]) : l;
                    return Ut(b(g([
                        Me(Zt),
                        (r = F2(function(n, r) {
                            return Et(c(n, r));
                        }), A3(Ce, 1, "resize", A2(jt, "target", A3(tt, r, A2(jt, "innerWidth", Vt), A2(jt, "innerHeight", Vt)))))
                    ]), e));
                },
                bc: gi,
                bd: function(n) {
                    var r = n.G, t = n.t;
                    if (r.$) {
                        var e = r.a.Y;
                        return t.$ ? A3(aa, e, $i, t.a) : A2(ha, e, n);
                    }
                    return pi("loading...");
                }
            })(A2(nt, function(n) {
                return et({
                    _: n
                });
            }, A2(jt, "countryDtos", ($u = A2(nt, function(n) {
                return A2(nt, function(r) {
                    return A2(nt, function(t) {
                        return A2(nt, function(e) {
                            return et({
                                V: e,
                                H: t,
                                k: r,
                                Z: n
                            });
                        }, A2(jt, "code", Xt));
                    }, A2(jt, "continent", Xt));
                }, A2(jt, "name", Xt));
            }, A2(jt, "population", Vt)), {
                $: 3,
                b: $u
            }))))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? u(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, gu) : n.Elm = gu;
}($a0b4f895e1596b3b$exports);


var $4fb3636b61cc3534$exports = {};
$4fb3636b61cc3534$exports = JSON.parse("[{\"country\":\"Afghanistan\",\"abbreviation\":\"AF\"},{\"country\":\"Albania\",\"abbreviation\":\"AL\"},{\"country\":\"Algeria\",\"abbreviation\":\"DZ\"},{\"country\":\"American Samoa\",\"abbreviation\":\"AS\"},{\"country\":\"Andorra\",\"abbreviation\":\"AD\"},{\"country\":\"Angola\",\"abbreviation\":\"AO\"},{\"country\":\"Anguilla\",\"abbreviation\":\"AI\"},{\"country\":\"Antarctica\",\"abbreviation\":\"AQ\"},{\"country\":\"Antigua and Barbuda\",\"abbreviation\":\"AG\"},{\"country\":\"Argentina\",\"abbreviation\":\"AR\"},{\"country\":\"Armenia\",\"abbreviation\":\"AM\"},{\"country\":\"Aruba\",\"abbreviation\":\"AW\"},{\"country\":\"Australia\",\"abbreviation\":\"AU\"},{\"country\":\"Austria\",\"abbreviation\":\"AT\"},{\"country\":\"Azerbaijan\",\"abbreviation\":\"AZ\"},{\"country\":\"Bahamas\",\"abbreviation\":\"BS\"},{\"country\":\"Bahrain\",\"abbreviation\":\"BH\"},{\"country\":\"Bangladesh\",\"abbreviation\":\"BD\"},{\"country\":\"Barbados\",\"abbreviation\":\"BB\"},{\"country\":\"Belarus\",\"abbreviation\":\"BY\"},{\"country\":\"Belgium\",\"abbreviation\":\"BE\"},{\"country\":\"Belize\",\"abbreviation\":\"BZ\"},{\"country\":\"Benin\",\"abbreviation\":\"BJ\"},{\"country\":\"Bermuda\",\"abbreviation\":\"BM\"},{\"country\":\"Bhutan\",\"abbreviation\":\"BT\"},{\"country\":\"Bolivia\",\"abbreviation\":\"BO\"},{\"country\":\"Bosnia and Herzegovina\",\"abbreviation\":\"BA\"},{\"country\":\"Botswana\",\"abbreviation\":\"BW\"},{\"country\":\"Bouvet Island\",\"abbreviation\":\"BV\"},{\"country\":\"Brazil\",\"abbreviation\":\"BR\"},{\"country\":\"British Indian Ocean Territory\",\"abbreviation\":\"IO\"},{\"country\":\"Brunei\",\"abbreviation\":\"BN\"},{\"country\":\"Bulgaria\",\"abbreviation\":\"BG\"},{\"country\":\"Burkina Faso\",\"abbreviation\":\"BF\"},{\"country\":\"Burundi\",\"abbreviation\":\"BI\"},{\"country\":\"Cambodia\",\"abbreviation\":\"KH\"},{\"country\":\"Cameroon\",\"abbreviation\":\"CM\"},{\"country\":\"Canada\",\"abbreviation\":\"CA\"},{\"country\":\"Cape Verde\",\"abbreviation\":\"CV\"},{\"country\":\"Cayman Islands\",\"abbreviation\":\"KY\"},{\"country\":\"Central African Republic\",\"abbreviation\":\"CF\"},{\"country\":\"Chad\",\"abbreviation\":\"TD\"},{\"country\":\"Chile\",\"abbreviation\":\"CL\"},{\"country\":\"China\",\"abbreviation\":\"CN\"},{\"country\":\"Christmas Island\",\"abbreviation\":\"CX\"},{\"_country\":\"Cocos (Keeling) Islands\",\"country\":\"Cocos Islands\",\"abbreviation\":\"CC\"},{\"country\":\"Colombia\",\"abbreviation\":\"CO\"},{\"country\":\"Comoros\",\"abbreviation\":\"KM\"},{\"country\":\"Congo\",\"abbreviation\":\"CG\"},{\"country\":\"Cook Islands\",\"abbreviation\":\"CK\"},{\"country\":\"Costa Rica\",\"abbreviation\":\"CR\"},{\"country\":\"Croatia\",\"abbreviation\":\"HR\"},{\"country\":\"Cuba\",\"abbreviation\":\"CU\"},{\"country\":\"Cyprus\",\"abbreviation\":\"CY\"},{\"country\":\"Czech Republic\",\"abbreviation\":\"CZ\"},{\"country\":\"Denmark\",\"abbreviation\":\"DK\"},{\"country\":\"Djibouti\",\"abbreviation\":\"DJ\"},{\"country\":\"Dominica\",\"abbreviation\":\"DM\"},{\"country\":\"Dominican Republic\",\"abbreviation\":\"DO\"},{\"country\":\"East Timor\",\"abbreviation\":\"TP\"},{\"country\":\"Ecuador\",\"abbreviation\":\"EC\"},{\"country\":\"Egypt\",\"abbreviation\":\"EG\"},{\"country\":\"El Salvador\",\"abbreviation\":\"SV\"},{\"country\":\"Equatorial Guinea\",\"abbreviation\":\"GQ\"},{\"country\":\"Eritrea\",\"abbreviation\":\"ER\"},{\"country\":\"Estonia\",\"abbreviation\":\"EE\"},{\"country\":\"Eswatini\",\"abbreviation\":\"SZ\"},{\"country\":\"Ethiopia\",\"abbreviation\":\"ET\"},{\"country\":\"Falkland Islands\",\"abbreviation\":\"FK\"},{\"country\":\"Faroe Islands\",\"abbreviation\":\"FO\"},{\"country\":\"Fiji Islands\",\"abbreviation\":\"FJ\"},{\"country\":\"Finland\",\"abbreviation\":\"FI\"},{\"country\":\"France\",\"abbreviation\":\"FR\"},{\"country\":\"French Guiana\",\"abbreviation\":\"GF\"},{\"country\":\"French Polynesia\",\"abbreviation\":\"PF\"},{\"country\":\"French Southern territories\",\"abbreviation\":\"TF\"},{\"country\":\"Gabon\",\"abbreviation\":\"GA\"},{\"country\":\"Gambia\",\"abbreviation\":\"GM\"},{\"country\":\"Georgia\",\"abbreviation\":\"GE\"},{\"country\":\"Germany\",\"abbreviation\":\"DE\"},{\"country\":\"Ghana\",\"abbreviation\":\"GH\"},{\"country\":\"Gibraltar\",\"abbreviation\":\"GI\"},{\"country\":\"Greece\",\"abbreviation\":\"GR\"},{\"country\":\"Greenland\",\"abbreviation\":\"GL\"},{\"country\":\"Grenada\",\"abbreviation\":\"GD\"},{\"country\":\"Guadeloupe\",\"abbreviation\":\"GP\"},{\"country\":\"Guam\",\"abbreviation\":\"GU\"},{\"country\":\"Guatemala\",\"abbreviation\":\"GT\"},{\"country\":\"Guernsey\",\"abbreviation\":\"GG\"},{\"country\":\"Guinea\",\"abbreviation\":\"GN\"},{\"country\":\"Guinea-Bissau\",\"abbreviation\":\"GW\"},{\"country\":\"Guyana\",\"abbreviation\":\"GY\"},{\"country\":\"Haiti\",\"abbreviation\":\"HT\"},{\"country\":\"Heard Island and McDonald Islands\",\"abbreviation\":\"HM\"},{\"_country\":\"Holy See (Vatican City State)\",\"country\":\"Vatican City\",\"abbreviation\":\"VA\"},{\"country\":\"Honduras\",\"abbreviation\":\"HN\"},{\"country\":\"Hong Kong\",\"abbreviation\":\"HK\"},{\"country\":\"Hungary\",\"abbreviation\":\"HU\"},{\"country\":\"Iceland\",\"abbreviation\":\"IS\"},{\"country\":\"India\",\"abbreviation\":\"IN\"},{\"country\":\"Indonesia\",\"abbreviation\":\"ID\"},{\"country\":\"Iran\",\"abbreviation\":\"IR\"},{\"country\":\"Iraq\",\"abbreviation\":\"IQ\"},{\"country\":\"Ireland\",\"abbreviation\":\"IE\"},{\"country\":\"Isle of Man\",\"abbreviation\":\"IM\"},{\"country\":\"Israel\",\"abbreviation\":\"IL\"},{\"country\":\"Italy\",\"abbreviation\":\"IT\"},{\"country\":\"Ivory Coast\",\"abbreviation\":\"CI\"},{\"country\":\"Jamaica\",\"abbreviation\":\"JM\"},{\"country\":\"Japan\",\"abbreviation\":\"JP\"},{\"country\":\"Jersey\",\"abbreviation\":\"JE\"},{\"country\":\"Jordan\",\"abbreviation\":\"JO\"},{\"country\":\"Kazakhstan\",\"abbreviation\":\"KZ\"},{\"country\":\"Kenya\",\"abbreviation\":\"KE\"},{\"country\":\"Kiribati\",\"abbreviation\":\"KI\"},{\"country\":\"Kuwait\",\"abbreviation\":\"KW\"},{\"country\":\"Kyrgyzstan\",\"abbreviation\":\"KG\"},{\"country\":\"Laos\",\"abbreviation\":\"LA\"},{\"country\":\"Latvia\",\"abbreviation\":\"LV\"},{\"country\":\"Lebanon\",\"abbreviation\":\"LB\"},{\"country\":\"Lesotho\",\"abbreviation\":\"LS\"},{\"country\":\"Liberia\",\"abbreviation\":\"LR\"},{\"country\":\"Libya\",\"abbreviation\":\"LY\"},{\"country\":\"Liechtenstein\",\"abbreviation\":\"LI\"},{\"country\":\"Lithuania\",\"abbreviation\":\"LT\"},{\"country\":\"Luxembourg\",\"abbreviation\":\"LU\"},{\"country\":\"Macao\",\"abbreviation\":\"MO\"},{\"country\":\"North Macedonia\",\"abbreviation\":\"MK\"},{\"country\":\"Madagascar\",\"abbreviation\":\"MG\"},{\"country\":\"Malawi\",\"abbreviation\":\"MW\"},{\"country\":\"Malaysia\",\"abbreviation\":\"MY\"},{\"country\":\"Maldives\",\"abbreviation\":\"MV\"},{\"country\":\"Mali\",\"abbreviation\":\"ML\"},{\"country\":\"Malta\",\"abbreviation\":\"MT\"},{\"country\":\"Marshall Islands\",\"abbreviation\":\"MH\"},{\"country\":\"Martinique\",\"abbreviation\":\"MQ\"},{\"country\":\"Mauritania\",\"abbreviation\":\"MR\"},{\"country\":\"Mauritius\",\"abbreviation\":\"MU\"},{\"country\":\"Mayotte\",\"abbreviation\":\"YT\"},{\"country\":\"Mexico\",\"abbreviation\":\"MX\"},{\"_country\":\"Micronesia, Federated States of\",\"country\":\"Micronesia\",\"abbreviation\":\"FM\"},{\"country\":\"Moldova\",\"abbreviation\":\"MD\"},{\"country\":\"Monaco\",\"abbreviation\":\"MC\"},{\"country\":\"Mongolia\",\"abbreviation\":\"MN\"},{\"country\":\"Montenegro\",\"abbreviation\":\"ME\"},{\"country\":\"Montserrat\",\"abbreviation\":\"MS\"},{\"country\":\"Morocco\",\"abbreviation\":\"MA\"},{\"country\":\"Mozambique\",\"abbreviation\":\"MZ\"},{\"country\":\"Myanmar\",\"abbreviation\":\"MM\"},{\"country\":\"Namibia\",\"abbreviation\":\"NA\"},{\"country\":\"Nauru\",\"abbreviation\":\"NR\"},{\"country\":\"Nepal\",\"abbreviation\":\"NP\"},{\"country\":\"Netherlands\",\"abbreviation\":\"NL\"},{\"country\":\"Netherlands Antilles\",\"abbreviation\":\"AN\"},{\"country\":\"New Caledonia\",\"abbreviation\":\"NC\"},{\"country\":\"New Zealand\",\"abbreviation\":\"NZ\"},{\"country\":\"Nicaragua\",\"abbreviation\":\"NI\"},{\"country\":\"Niger\",\"abbreviation\":\"NE\"},{\"country\":\"Nigeria\",\"abbreviation\":\"NG\"},{\"country\":\"Niue\",\"abbreviation\":\"NU\"},{\"country\":\"Norfolk Island\",\"abbreviation\":\"NF\"},{\"country\":\"North Korea\",\"abbreviation\":\"KP\"},{\"country\":\"Northern Ireland\",\"abbreviation\":\"GB\"},{\"country\":\"Northern Mariana Islands\",\"abbreviation\":\"MP\"},{\"country\":\"Norway\",\"abbreviation\":\"NO\"},{\"country\":\"Oman\",\"abbreviation\":\"OM\"},{\"country\":\"Pakistan\",\"abbreviation\":\"PK\"},{\"country\":\"Palau\",\"abbreviation\":\"PW\"},{\"country\":\"Palestine\",\"abbreviation\":\"PS\"},{\"country\":\"Panama\",\"abbreviation\":\"PA\"},{\"country\":\"Papua New Guinea\",\"abbreviation\":\"PG\"},{\"country\":\"Paraguay\",\"abbreviation\":\"PY\"},{\"country\":\"Peru\",\"abbreviation\":\"PE\"},{\"country\":\"Philippines\",\"abbreviation\":\"PH\"},{\"country\":\"Pitcairn\",\"abbreviation\":\"PN\"},{\"country\":\"Poland\",\"abbreviation\":\"PL\"},{\"country\":\"Portugal\",\"abbreviation\":\"PT\"},{\"country\":\"Puerto Rico\",\"abbreviation\":\"PR\"},{\"country\":\"Qatar\",\"abbreviation\":\"QA\"},{\"country\":\"Reunion\",\"abbreviation\":\"RE\"},{\"country\":\"Romania\",\"abbreviation\":\"RO\"},{\"country\":\"Russia\",\"abbreviation\":\"RU\"},{\"country\":\"Rwanda\",\"abbreviation\":\"RW\"},{\"country\":\"Saint Helena\",\"abbreviation\":\"SH\"},{\"country\":\"Saint Kitts and Nevis\",\"abbreviation\":\"KN\"},{\"country\":\"Saint Lucia\",\"abbreviation\":\"LC\"},{\"country\":\"Saint Pierre and Miquelon\",\"abbreviation\":\"PM\"},{\"country\":\"Saint Vincent and the Grenadines\",\"abbreviation\":\"VC\"},{\"country\":\"Samoa\",\"abbreviation\":\"WS\"},{\"country\":\"San Marino\",\"abbreviation\":\"SM\"},{\"country\":\"Sao Tome and Principe\",\"abbreviation\":\"ST\"},{\"country\":\"Saudi Arabia\",\"abbreviation\":\"SA\"},{\"country\":\"Senegal\",\"abbreviation\":\"SN\"},{\"country\":\"Serbia\",\"abbreviation\":\"RS\"},{\"country\":\"Seychelles\",\"abbreviation\":\"SC\"},{\"country\":\"Sierra Leone\",\"abbreviation\":\"SL\"},{\"country\":\"Singapore\",\"abbreviation\":\"SG\"},{\"country\":\"Slovakia\",\"abbreviation\":\"SK\"},{\"country\":\"Slovenia\",\"abbreviation\":\"SI\"},{\"country\":\"Solomon Islands\",\"abbreviation\":\"SB\"},{\"country\":\"Somalia\",\"abbreviation\":\"SO\"},{\"country\":\"South Africa\",\"abbreviation\":\"ZA\"},{\"country\":\"South Georgia and the South Sandwich Islands\",\"abbreviation\":\"GS\"},{\"country\":\"South Korea\",\"abbreviation\":\"KR\"},{\"country\":\"South Sudan\",\"abbreviation\":\"SS\"},{\"country\":\"Spain\",\"abbreviation\":\"ES\"},{\"country\":\"Sri Lanka\",\"abbreviation\":\"LK\"},{\"country\":\"Sudan\",\"abbreviation\":\"SD\"},{\"country\":\"Suriname\",\"abbreviation\":\"SR\"},{\"_country\":\"Svalbard and Jan Mayen\",\"_abbreviation\":\"SJ\"},{\"country\":\"Sweden\",\"abbreviation\":\"SE\"},{\"country\":\"Switzerland\",\"abbreviation\":\"CH\"},{\"country\":\"Syria\",\"abbreviation\":\"SY\"},{\"country\":\"Tajikistan\",\"abbreviation\":\"TJ\"},{\"country\":\"Tanzania\",\"abbreviation\":\"TZ\"},{\"country\":\"Thailand\",\"abbreviation\":\"TH\"},{\"country\":\"The Democratic Republic of Congo\",\"abbreviation\":\"CD\"},{\"country\":\"Timor-Leste\",\"abbreviation\":\"TL\"},{\"country\":\"Togo\",\"abbreviation\":\"TG\"},{\"country\":\"Tokelau\",\"abbreviation\":\"TK\"},{\"country\":\"Tonga\",\"abbreviation\":\"TO\"},{\"country\":\"Trinidad and Tobago\",\"abbreviation\":\"TT\"},{\"country\":\"Tunisia\",\"abbreviation\":\"TN\"},{\"country\":\"Turkey\",\"abbreviation\":\"TR\"},{\"country\":\"Turkmenistan\",\"abbreviation\":\"TM\"},{\"country\":\"Turks and Caicos Islands\",\"abbreviation\":\"TC\"},{\"country\":\"Tuvalu\",\"abbreviation\":\"TV\"},{\"country\":\"Uganda\",\"abbreviation\":\"UG\"},{\"country\":\"Ukraine\",\"abbreviation\":\"UA\"},{\"country\":\"United Arab Emirates\",\"abbreviation\":\"AE\"},{\"country\":\"United Kingdom\",\"abbreviation\":\"UK\"},{\"country\":\"United States\",\"abbreviation\":\"US\"},{\"country\":\"United States Minor Outlying Islands\",\"abbreviation\":\"UM\"},{\"country\":\"Uruguay\",\"abbreviation\":\"UY\"},{\"country\":\"Uzbekistan\",\"abbreviation\":\"UZ\"},{\"country\":\"Vanuatu\",\"abbreviation\":\"VU\"},{\"country\":\"Venezuela\",\"abbreviation\":\"VE\"},{\"country\":\"Vietnam\",\"abbreviation\":\"VN\"},{\"_country\":\"Virgin Islands, British\",\"country\":\"British Virgin Islands\",\"abbreviation\":\"VG\"},{\"_country\":\"Virgin Islands, U.S.\",\"country\":\"United States Virgin Islands\",\"abbreviation\":\"VI\"},{\"country\":\"Wallis and Futuna\",\"abbreviation\":\"WF\"},{\"country\":\"Western Sahara\",\"abbreviation\":\"EH\"},{\"country\":\"Yemen\",\"abbreviation\":\"YE\"},{\"country\":\"Zambia\",\"abbreviation\":\"ZM\"},{\"country\":\"Zimbabwe\",\"abbreviation\":\"ZW\"}]");


var $c8658b6091143556$exports = {};
$c8658b6091143556$exports = JSON.parse("[{\"country\":\"Afghanistan\",\"continent\":\"Asia\"},{\"country\":\"Albania\",\"continent\":\"Europe\"},{\"country\":\"Algeria\",\"continent\":\"Africa\"},{\"country\":\"American Samoa\",\"continent\":\"Oceania\"},{\"country\":\"Andorra\",\"continent\":\"Europe\"},{\"country\":\"Angola\",\"continent\":\"Africa\"},{\"country\":\"Anguilla\",\"continent\":\"North America\"},{\"country\":\"Antarctica\",\"continent\":\"Antarctica\"},{\"country\":\"Antigua and Barbuda\",\"continent\":\"North America\"},{\"country\":\"Argentina\",\"continent\":\"South America\"},{\"country\":\"Armenia\",\"continent\":\"Asia\"},{\"country\":\"Aruba\",\"continent\":\"North America\"},{\"country\":\"Australia\",\"continent\":\"Oceania\"},{\"country\":\"Austria\",\"continent\":\"Europe\"},{\"country\":\"Azerbaijan\",\"continent\":\"Asia\"},{\"country\":\"Bahamas\",\"continent\":\"North America\"},{\"country\":\"Bahrain\",\"continent\":\"Asia\"},{\"country\":\"Bangladesh\",\"continent\":\"Asia\"},{\"country\":\"Barbados\",\"continent\":\"North America\"},{\"country\":\"Belarus\",\"continent\":\"Europe\"},{\"country\":\"Belgium\",\"continent\":\"Europe\"},{\"country\":\"Belize\",\"continent\":\"North America\"},{\"country\":\"Benin\",\"continent\":\"Africa\"},{\"country\":\"Bermuda\",\"continent\":\"North America\"},{\"country\":\"Bhutan\",\"continent\":\"Asia\"},{\"country\":\"Bolivia\",\"continent\":\"South America\"},{\"country\":\"Bosnia and Herzegovina\",\"continent\":\"Europe\"},{\"country\":\"Botswana\",\"continent\":\"Africa\"},{\"country\":\"Bouvet Island\",\"continent\":\"Antarctica\"},{\"country\":\"Brazil\",\"continent\":\"South America\"},{\"country\":\"British Indian Ocean Territory\",\"continent\":\"Africa\"},{\"country\":\"Brunei\",\"continent\":\"Asia\"},{\"country\":\"Bulgaria\",\"continent\":\"Europe\"},{\"country\":\"Burkina Faso\",\"continent\":\"Africa\"},{\"country\":\"Burundi\",\"continent\":\"Africa\"},{\"country\":\"Cambodia\",\"continent\":\"Asia\"},{\"country\":\"Cameroon\",\"continent\":\"Africa\"},{\"country\":\"Canada\",\"continent\":\"North America\"},{\"country\":\"Cape Verde\",\"continent\":\"Africa\"},{\"country\":\"Cayman Islands\",\"continent\":\"North America\"},{\"country\":\"Central African Republic\",\"continent\":\"Africa\"},{\"country\":\"Chad\",\"continent\":\"Africa\"},{\"country\":\"Chile\",\"continent\":\"South America\"},{\"country\":\"China\",\"continent\":\"Asia\"},{\"country\":\"Christmas Island\",\"continent\":\"Oceania\"},{\"country\":\"Cocos (Keeling) Islands\",\"continent\":\"Oceania\"},{\"country\":\"Colombia\",\"continent\":\"South America\"},{\"country\":\"Comoros\",\"continent\":\"Africa\"},{\"country\":\"Congo\",\"continent\":\"Africa\"},{\"country\":\"Cook Islands\",\"continent\":\"Oceania\"},{\"country\":\"Costa Rica\",\"continent\":\"North America\"},{\"country\":\"Croatia\",\"continent\":\"Europe\"},{\"country\":\"Cuba\",\"continent\":\"North America\"},{\"country\":\"Cyprus\",\"continent\":\"Asia\"},{\"country\":\"Czech Republic\",\"continent\":\"Europe\"},{\"country\":\"Denmark\",\"continent\":\"Europe\"},{\"country\":\"Djibouti\",\"continent\":\"Africa\"},{\"country\":\"Dominica\",\"continent\":\"North America\"},{\"country\":\"Dominican Republic\",\"continent\":\"North America\"},{\"country\":\"East Timor\",\"continent\":\"Asia\"},{\"country\":\"Ecuador\",\"continent\":\"South America\"},{\"country\":\"Egypt\",\"continent\":\"Africa\"},{\"country\":\"El Salvador\",\"continent\":\"North America\"},{\"country\":\"England\",\"continent\":\"Europe\"},{\"country\":\"Equatorial Guinea\",\"continent\":\"Africa\"},{\"country\":\"Eritrea\",\"continent\":\"Africa\"},{\"country\":\"Estonia\",\"continent\":\"Europe\"},{\"country\":\"Eswatini\",\"continent\":\"Africa\"},{\"country\":\"Ethiopia\",\"continent\":\"Africa\"},{\"country\":\"Falkland Islands\",\"continent\":\"South America\"},{\"country\":\"Faroe Islands\",\"continent\":\"Europe\"},{\"country\":\"Fiji Islands\",\"continent\":\"Oceania\"},{\"country\":\"Finland\",\"continent\":\"Europe\"},{\"country\":\"France\",\"continent\":\"Europe\"},{\"country\":\"French Guiana\",\"continent\":\"South America\"},{\"country\":\"French Polynesia\",\"continent\":\"Oceania\"},{\"country\":\"French Southern territories\",\"continent\":\"Antarctica\"},{\"country\":\"Gabon\",\"continent\":\"Africa\"},{\"country\":\"Gambia\",\"continent\":\"Africa\"},{\"country\":\"Georgia\",\"continent\":\"Asia\"},{\"country\":\"Germany\",\"continent\":\"Europe\"},{\"country\":\"Ghana\",\"continent\":\"Africa\"},{\"country\":\"Gibraltar\",\"continent\":\"Europe\"},{\"country\":\"Greece\",\"continent\":\"Europe\"},{\"country\":\"Greenland\",\"continent\":\"North America\"},{\"country\":\"Grenada\",\"continent\":\"North America\"},{\"country\":\"Guadeloupe\",\"continent\":\"North America\"},{\"country\":\"Guam\",\"continent\":\"Oceania\"},{\"country\":\"Guatemala\",\"continent\":\"North America\"},{\"country\":\"Guinea\",\"continent\":\"Africa\"},{\"country\":\"Guinea-Bissau\",\"continent\":\"Africa\"},{\"country\":\"Guyana\",\"continent\":\"South America\"},{\"country\":\"Haiti\",\"continent\":\"North America\"},{\"country\":\"Heard Island and McDonald Islands\",\"continent\":\"Antarctica\"},{\"country\":\"Holy See (Vatican City State)\",\"continent\":\"Europe\"},{\"country\":\"Honduras\",\"continent\":\"North America\"},{\"country\":\"Hong Kong\",\"continent\":\"Asia\"},{\"country\":\"Hungary\",\"continent\":\"Europe\"},{\"country\":\"Iceland\",\"continent\":\"Europe\"},{\"country\":\"India\",\"continent\":\"Asia\"},{\"country\":\"Indonesia\",\"continent\":\"Asia\"},{\"country\":\"Iran\",\"continent\":\"Asia\"},{\"country\":\"Iraq\",\"continent\":\"Asia\"},{\"country\":\"Ireland\",\"continent\":\"Europe\"},{\"country\":\"Israel\",\"continent\":\"Asia\"},{\"country\":\"Italy\",\"continent\":\"Europe\"},{\"country\":\"Ivory Coast\",\"continent\":\"Africa\"},{\"country\":\"Jamaica\",\"continent\":\"North America\"},{\"country\":\"Japan\",\"continent\":\"Asia\"},{\"country\":\"Jordan\",\"continent\":\"Asia\"},{\"country\":\"Kazakhstan\",\"continent\":\"Asia\"},{\"country\":\"Kenya\",\"continent\":\"Africa\"},{\"country\":\"Kiribati\",\"continent\":\"Oceania\"},{\"country\":\"Kuwait\",\"continent\":\"Asia\"},{\"country\":\"Kyrgyzstan\",\"continent\":\"Asia\"},{\"country\":\"Laos\",\"continent\":\"Asia\"},{\"country\":\"Latvia\",\"continent\":\"Europe\"},{\"country\":\"Lebanon\",\"continent\":\"Asia\"},{\"country\":\"Lesotho\",\"continent\":\"Africa\"},{\"country\":\"Liberia\",\"continent\":\"Africa\"},{\"country\":\"Libya\",\"continent\":\"Africa\"},{\"country\":\"Liechtenstein\",\"continent\":\"Europe\"},{\"country\":\"Lithuania\",\"continent\":\"Europe\"},{\"country\":\"Luxembourg\",\"continent\":\"Europe\"},{\"country\":\"Macao\",\"continent\":\"Asia\"},{\"country\":\"North Macedonia\",\"continent\":\"Europe\"},{\"country\":\"Madagascar\",\"continent\":\"Africa\"},{\"country\":\"Malawi\",\"continent\":\"Africa\"},{\"country\":\"Malaysia\",\"continent\":\"Asia\"},{\"country\":\"Maldives\",\"continent\":\"Asia\"},{\"country\":\"Mali\",\"continent\":\"Africa\"},{\"country\":\"Malta\",\"continent\":\"Europe\"},{\"country\":\"Marshall Islands\",\"continent\":\"Oceania\"},{\"country\":\"Martinique\",\"continent\":\"North America\"},{\"country\":\"Mauritania\",\"continent\":\"Africa\"},{\"country\":\"Mauritius\",\"continent\":\"Africa\"},{\"country\":\"Mayotte\",\"continent\":\"Africa\"},{\"country\":\"Mexico\",\"continent\":\"North America\"},{\"country\":\"Micronesia, Federated States of\",\"continent\":\"Oceania\"},{\"country\":\"Moldova\",\"continent\":\"Europe\"},{\"country\":\"Monaco\",\"continent\":\"Europe\"},{\"country\":\"Mongolia\",\"continent\":\"Asia\"},{\"country\":\"Montenegro\",\"continent\":\"Europe\"},{\"country\":\"Montserrat\",\"continent\":\"North America\"},{\"country\":\"Morocco\",\"continent\":\"Africa\"},{\"country\":\"Mozambique\",\"continent\":\"Africa\"},{\"country\":\"Myanmar\",\"continent\":\"Asia\"},{\"country\":\"Namibia\",\"continent\":\"Africa\"},{\"country\":\"Nauru\",\"continent\":\"Oceania\"},{\"country\":\"Nepal\",\"continent\":\"Asia\"},{\"country\":\"Netherlands\",\"continent\":\"Europe\"},{\"country\":\"Netherlands Antilles\",\"continent\":\"North America\"},{\"country\":\"New Caledonia\",\"continent\":\"Oceania\"},{\"country\":\"New Zealand\",\"continent\":\"Oceania\"},{\"country\":\"Nicaragua\",\"continent\":\"North America\"},{\"country\":\"Niger\",\"continent\":\"Africa\"},{\"country\":\"Nigeria\",\"continent\":\"Africa\"},{\"country\":\"Niue\",\"continent\":\"Oceania\"},{\"country\":\"Norfolk Island\",\"continent\":\"Oceania\"},{\"country\":\"North Korea\",\"continent\":\"Asia\"},{\"country\":\"Northern Ireland\",\"continent\":\"Europe\"},{\"country\":\"Northern Mariana Islands\",\"continent\":\"Oceania\"},{\"country\":\"Norway\",\"continent\":\"Europe\"},{\"country\":\"Oman\",\"continent\":\"Asia\"},{\"country\":\"Pakistan\",\"continent\":\"Asia\"},{\"country\":\"Palau\",\"continent\":\"Oceania\"},{\"country\":\"Palestine\",\"continent\":\"Asia\"},{\"country\":\"Panama\",\"continent\":\"North America\"},{\"country\":\"Papua New Guinea\",\"continent\":\"Oceania\"},{\"country\":\"Paraguay\",\"continent\":\"South America\"},{\"country\":\"Peru\",\"continent\":\"South America\"},{\"country\":\"Philippines\",\"continent\":\"Asia\"},{\"country\":\"Pitcairn\",\"continent\":\"Oceania\"},{\"country\":\"Poland\",\"continent\":\"Europe\"},{\"country\":\"Portugal\",\"continent\":\"Europe\"},{\"country\":\"Puerto Rico\",\"continent\":\"North America\"},{\"country\":\"Qatar\",\"continent\":\"Asia\"},{\"country\":\"Reunion\",\"continent\":\"Africa\"},{\"country\":\"Romania\",\"continent\":\"Europe\"},{\"country\":\"Russia\",\"continent\":\"Europe&Asia\"},{\"country\":\"Rwanda\",\"continent\":\"Africa\"},{\"country\":\"Saint Helena\",\"continent\":\"Africa\"},{\"country\":\"Saint Kitts and Nevis\",\"continent\":\"North America\"},{\"country\":\"Saint Lucia\",\"continent\":\"North America\"},{\"country\":\"Saint Pierre and Miquelon\",\"continent\":\"North America\"},{\"country\":\"Saint Vincent and the Grenadines\",\"continent\":\"North America\"},{\"country\":\"Samoa\",\"continent\":\"Oceania\"},{\"country\":\"San Marino\",\"continent\":\"Europe\"},{\"country\":\"Sao Tome and Principe\",\"continent\":\"Africa\"},{\"country\":\"Saudi Arabia\",\"continent\":\"Asia\"},{\"country\":\"Scotland\",\"continent\":\"Europe\"},{\"country\":\"Senegal\",\"continent\":\"Africa\"},{\"country\":\"Serbia\",\"continent\":\"Europe\"},{\"country\":\"Seychelles\",\"continent\":\"Africa\"},{\"country\":\"Sierra Leone\",\"continent\":\"Africa\"},{\"country\":\"Singapore\",\"continent\":\"Asia\"},{\"country\":\"Slovakia\",\"continent\":\"Europe\"},{\"country\":\"Slovenia\",\"continent\":\"Europe\"},{\"country\":\"Solomon Islands\",\"continent\":\"Oceania\"},{\"country\":\"Somalia\",\"continent\":\"Africa\"},{\"country\":\"South Africa\",\"continent\":\"Africa\"},{\"country\":\"South Georgia and the South Sandwich Islands\",\"continent\":\"Antarctica\"},{\"country\":\"South Korea\",\"continent\":\"Asia\"},{\"country\":\"South Sudan\",\"continent\":\"Africa\"},{\"country\":\"Spain\",\"continent\":\"Europe\"},{\"country\":\"Sri Lanka\",\"continent\":\"Asia\"},{\"country\":\"Sudan\",\"continent\":\"Africa\"},{\"country\":\"Suriname\",\"continent\":\"South America\"},{\"country\":\"Svalbard and Jan Mayen\",\"continent\":\"Europe\"},{\"country\":\"Sweden\",\"continent\":\"Europe\"},{\"country\":\"Switzerland\",\"continent\":\"Europe\"},{\"country\":\"Syria\",\"continent\":\"Asia\"},{\"country\":\"Tajikistan\",\"continent\":\"Asia\"},{\"country\":\"Tanzania\",\"continent\":\"Africa\"},{\"country\":\"Thailand\",\"continent\":\"Asia\"},{\"country\":\"The Democratic Republic of Congo\",\"continent\":\"Africa\"},{\"country\":\"Togo\",\"continent\":\"Africa\"},{\"country\":\"Tokelau\",\"continent\":\"Oceania\"},{\"country\":\"Tonga\",\"continent\":\"Oceania\"},{\"country\":\"Trinidad and Tobago\",\"continent\":\"North America\"},{\"country\":\"Tunisia\",\"continent\":\"Africa\"},{\"country\":\"Turkey\",\"continent\":\"Asia\"},{\"country\":\"Turkmenistan\",\"continent\":\"Asia\"},{\"country\":\"Turks and Caicos Islands\",\"continent\":\"North America\"},{\"country\":\"Tuvalu\",\"continent\":\"Oceania\"},{\"country\":\"Uganda\",\"continent\":\"Africa\"},{\"country\":\"Ukraine\",\"continent\":\"Europe\"},{\"country\":\"United Arab Emirates\",\"continent\":\"Asia\"},{\"country\":\"United Kingdom\",\"continent\":\"Europe\"},{\"country\":\"United States\",\"continent\":\"North America\"},{\"country\":\"United States Minor Outlying Islands\",\"continent\":\"Oceania\"},{\"country\":\"Uruguay\",\"continent\":\"South America\"},{\"country\":\"Uzbekistan\",\"continent\":\"Asia\"},{\"country\":\"Vanuatu\",\"continent\":\"Oceania\"},{\"country\":\"Venezuela\",\"continent\":\"South America\"},{\"country\":\"Vietnam\",\"continent\":\"Asia\"},{\"country\":\"Virgin Islands, British\",\"continent\":\"North America\"},{\"country\":\"Virgin Islands, U.S.\",\"continent\":\"North America\"},{\"country\":\"Wales\",\"continent\":\"Europe\"},{\"country\":\"Wallis and Futuna\",\"continent\":\"Oceania\"},{\"country\":\"Western Sahara\",\"continent\":\"Africa\"},{\"country\":\"Yemen\",\"continent\":\"Asia\"},{\"country\":\"Zambia\",\"continent\":\"Africa\"},{\"country\":\"Zimbabwe\",\"continent\":\"Africa\"}]");


var $b71e50e32221a217$exports = {};
$b71e50e32221a217$exports = JSON.parse("[{\"country\":\"Afghanistan\",\"population\":37172386},{\"country\":\"Albania\",\"population\":2866376},{\"country\":\"Algeria\",\"population\":42228429},{\"country\":\"American Samoa\",\"population\":55465},{\"country\":\"Andorra\",\"population\":77006},{\"country\":\"Angola\",\"population\":30809762},{\"country\":\"Anguilla\",\"population\":15094},{\"country\":\"Antarctica\",\"population\":1106},{\"country\":\"Antigua and Barbuda\",\"population\":96286},{\"country\":\"Argentina\",\"population\":44494502},{\"country\":\"Armenia\",\"population\":2951776},{\"country\":\"Aruba\",\"population\":105845},{\"country\":\"Australia\",\"population\":24982688},{\"country\":\"Austria\",\"population\":8840521},{\"country\":\"Azerbaijan\",\"population\":9939800},{\"country\":\"Bahamas\",\"population\":385640},{\"country\":\"Bahrain\",\"population\":1569439},{\"country\":\"Bangladesh\",\"population\":161356039},{\"country\":\"Barbados\",\"population\":286641},{\"country\":\"Belarus\",\"population\":9483499},{\"country\":\"Belgium\",\"population\":11433256},{\"country\":\"Belize\",\"population\":383071},{\"country\":\"Benin\",\"population\":11485048},{\"country\":\"Bermuda\",\"population\":63973},{\"country\":\"Bhutan\",\"population\":754394},{\"country\":\"Bolivia\",\"population\":11353142},{\"country\":\"Bosnia and Herzegovina\",\"population\":3323929},{\"country\":\"Botswana\",\"population\":2254126},{\"country\":\"Bouvet Island\",\"population\":0},{\"country\":\"Brazil\",\"population\":209469333},{\"country\":\"British Indian Ocean Territory\",\"population\":0},{\"country\":\"Brunei\",\"population\":428962},{\"country\":\"Bulgaria\",\"population\":7025037},{\"country\":\"Burkina Faso\",\"population\":19751535},{\"country\":\"Burundi\",\"population\":11175378},{\"country\":\"Cabo Verde\",\"population\":555987},{\"country\":\"Cambodia\",\"population\":16249798},{\"country\":\"Cameroon\",\"population\":25216237},{\"country\":\"Canada\",\"population\":37057765},{\"country\":\"Cape Verde\",\"population\":543767},{\"country\":\"Cayman Islands\",\"population\":64174},{\"country\":\"Central African Republic\",\"population\":4666377},{\"country\":\"Chad\",\"population\":15477751},{\"country\":\"Chile\",\"population\":18729160},{\"country\":\"China\",\"population\":1392730000},{\"country\":\"Christmas Island\",\"population\":1402},{\"country\":\"Cocos (Keeling) Islands\",\"population\":596},{\"country\":\"Colombia\",\"population\":49648685},{\"country\":\"Comoros\",\"population\":832322},{\"country\":\"Congo\",\"population\":5244363},{\"country\":\"Cook Islands\",\"population\":17379},{\"country\":\"Costa Rica\",\"population\":4999441},{\"country\":\"Croatia\",\"population\":4087843},{\"country\":\"Cuba\",\"population\":11338138},{\"country\":\"Cyprus\",\"population\":1189265},{\"country\":\"Czech Republic\",\"population\":10629928},{\"country\":\"Denmark\",\"population\":5793636},{\"country\":\"Djibouti\",\"population\":958920},{\"country\":\"Dominica\",\"population\":71625},{\"country\":\"Dominican Republic\",\"population\":10627165},{\"country\":\"East Timor\",\"population\":1267972},{\"country\":\"Ecuador\",\"population\":17084357},{\"country\":\"Egypt\",\"population\":98423595},{\"country\":\"El Salvador\",\"population\":6420744},{\"country\":\"England\",\"population\":55619400},{\"country\":\"Equatorial Guinea\",\"population\":1308974},{\"country\":\"Eritrea\",\"population\":6213972},{\"country\":\"Estonia\",\"population\":1321977},{\"country\":\"Eswatini\",\"population\":1136191},{\"country\":\"Ethiopia\",\"population\":109224559},{\"country\":\"Falkland Islands\",\"population\":2840},{\"country\":\"Faroe Islands\",\"population\":48497},{\"country\":\"Fiji Islands\",\"population\":883483},{\"country\":\"Finland\",\"population\":5515525},{\"country\":\"France\",\"population\":66977107},{\"country\":\"French Guiana\",\"population\":290691},{\"country\":\"French Polynesia\",\"population\":277679},{\"country\":\"French Southern territories\",\"population\":0},{\"country\":\"Gabon\",\"population\":2119275},{\"country\":\"Gambia\",\"population\":2280102},{\"country\":\"Georgia\",\"population\":3726549},{\"country\":\"Germany\",\"population\":82905782},{\"country\":\"Ghana\",\"population\":29767108},{\"country\":\"Gibraltar\",\"population\":33718},{\"country\":\"Greece\",\"population\":10731726},{\"country\":\"Greenland\",\"population\":56025},{\"country\":\"Grenada\",\"population\":111454},{\"country\":\"Guadeloupe\",\"population\":395700},{\"country\":\"Guam\",\"population\":165768},{\"country\":\"Guatemala\",\"population\":17247807},{\"country\":\"Guinea\",\"population\":12414318},{\"country\":\"Guinea-Bissau\",\"population\":1874309},{\"country\":\"Guyana\",\"population\":779004},{\"country\":\"Haiti\",\"population\":11123176},{\"country\":\"Heard Island and McDonald Islands\",\"population\":0},{\"country\":\"Holy See (Vatican City State)\",\"population\":825},{\"country\":\"Honduras\",\"population\":9587522},{\"country\":\"Hong Kong\",\"population\":7451000},{\"country\":\"Hungary\",\"population\":9775564},{\"country\":\"Iceland\",\"population\":352721},{\"country\":\"India\",\"population\":1352617328},{\"country\":\"Indonesia\",\"population\":267663435},{\"country\":\"Iran\",\"population\":81800269},{\"country\":\"Iraq\",\"population\":38433600},{\"country\":\"Ireland\",\"population\":4867309},{\"country\":\"Israel\",\"population\":8882800},{\"country\":\"Italy\",\"population\":60421760},{\"country\":\"Ivory Coast\",\"population\":25069229},{\"country\":\"Jamaica\",\"population\":2934855},{\"country\":\"Japan\",\"population\":126529100},{\"country\":\"Jordan\",\"population\":9956011},{\"country\":\"Kazakhstan\",\"population\":18272430},{\"country\":\"Kenya\",\"population\":51393010},{\"country\":\"Kiribati\",\"population\":115847},{\"country\":\"Kuwait\",\"population\":4137309},{\"country\":\"Kyrgyzstan\",\"population\":6322800},{\"country\":\"Laos\",\"population\":7061507},{\"country\":\"Latvia\",\"population\":1927174},{\"country\":\"Lebanon\",\"population\":6848925},{\"country\":\"Lesotho\",\"population\":2108132},{\"country\":\"Liberia\",\"population\":4818977},{\"country\":\"Libya\",\"population\":6678567},{\"country\":\"Liechtenstein\",\"population\":37910},{\"country\":\"Lithuania\",\"population\":2801543},{\"country\":\"Luxembourg\",\"population\":607950},{\"country\":\"Macao\",\"population\":631636},{\"country\":\"North Macedonia\",\"population\":2084367},{\"country\":\"Madagascar\",\"population\":26262368},{\"country\":\"Malawi\",\"population\":18143315},{\"country\":\"Malaysia\",\"population\":31528585},{\"country\":\"Maldives\",\"population\":515696},{\"country\":\"Mali\",\"population\":19077690},{\"country\":\"Malta\",\"population\":484630},{\"country\":\"Marshall Islands\",\"population\":58413},{\"country\":\"Martinique\",\"population\":376480},{\"country\":\"Mauritania\",\"population\":4403319},{\"country\":\"Mauritius\",\"population\":1265303},{\"country\":\"Mayotte\",\"population\":270372},{\"country\":\"Mexico\",\"population\":126190788},{\"country\":\"Micronesia, Federated States of\",\"population\":112640},{\"country\":\"Moldova\",\"population\":2706049},{\"country\":\"Monaco\",\"population\":38682},{\"country\":\"Mongolia\",\"population\":3170208},{\"country\":\"Montenegro\",\"population\":631219},{\"country\":\"Montserrat\",\"population\":5900},{\"country\":\"Morocco\",\"population\":36029138},{\"country\":\"Mozambique\",\"population\":29495962},{\"country\":\"Myanmar\",\"population\":53708395},{\"country\":\"Namibia\",\"population\":2448255},{\"country\":\"Nauru\",\"population\":12704},{\"country\":\"Nepal\",\"population\":28087871},{\"country\":\"Netherlands\",\"population\":17231624},{\"country\":\"Netherlands Antilles\",\"population\":227049},{\"country\":\"New Caledonia\",\"population\":284060},{\"country\":\"New Zealand\",\"population\":4841000},{\"country\":\"Nicaragua\",\"population\":6465513},{\"country\":\"Niger\",\"population\":22442948},{\"country\":\"Nigeria\",\"population\":195874740},{\"country\":\"Niue\",\"population\":1624},{\"country\":\"Norfolk Island\",\"population\":2169},{\"country\":\"North Korea\",\"population\":25549819},{\"country\":\"Northern Ireland\",\"population\":1885400},{\"country\":\"Northern Mariana Islands\",\"population\":56882},{\"country\":\"Norway\",\"population\":5311916},{\"country\":\"Oman\",\"population\":4829483},{\"country\":\"Pakistan\",\"population\":212215030},{\"country\":\"Palau\",\"population\":17907},{\"country\":\"Palestine\",\"population\":4569087},{\"country\":\"Panama\",\"population\":4176873},{\"country\":\"Papua New Guinea\",\"population\":8606316},{\"country\":\"Paraguay\",\"population\":6956071},{\"country\":\"Peru\",\"population\":31989256},{\"country\":\"Philippines\",\"population\":106651922},{\"country\":\"Pitcairn\",\"population\":67},{\"country\":\"Poland\",\"population\":37974750},{\"country\":\"Portugal\",\"population\":10283822},{\"country\":\"Puerto Rico\",\"population\":3195153},{\"country\":\"Qatar\",\"population\":2781677},{\"country\":\"Reunion\",\"population\":859959},{\"country\":\"Romania\",\"population\":19466145},{\"country\":\"Russia\",\"population\":144478050},{\"country\":\"Rwanda\",\"population\":12301939},{\"country\":\"Saint Helena\",\"population\":6600},{\"country\":\"Saint Kitts and Nevis\",\"population\":52441},{\"country\":\"Saint Lucia\",\"population\":181889},{\"country\":\"Saint Pierre and Miquelon\",\"population\":5888},{\"country\":\"Saint Vincent and the Grenadines\",\"population\":110210},{\"country\":\"Samoa\",\"population\":196130},{\"country\":\"San Marino\",\"population\":33785},{\"country\":\"Sao Tome and Principe\",\"population\":211028},{\"country\":\"Saudi Arabia\",\"population\":33699947},{\"country\":\"Scotland\",\"population\":5424800},{\"country\":\"Senegal\",\"population\":15854360},{\"country\":\"Serbia\",\"population\":6963764},{\"country\":\"Seychelles\",\"population\":96762},{\"country\":\"Sierra Leone\",\"population\":7650154},{\"country\":\"Singapore\",\"population\":5638676},{\"country\":\"Slovakia\",\"population\":5446771},{\"country\":\"Slovenia\",\"population\":2073894},{\"country\":\"Solomon Islands\",\"population\":652858},{\"country\":\"Somalia\",\"population\":15008154},{\"country\":\"South Africa\",\"population\":57779622},{\"country\":\"South Georgia and the South Sandwich Islands\",\"population\":30},{\"country\":\"South Korea\",\"population\":51606633},{\"country\":\"South Sudan\",\"population\":10975920},{\"country\":\"Spain\",\"population\":46796540},{\"country\":\"Sri Lanka\",\"population\":21670000},{\"country\":\"Sudan\",\"population\":41801533},{\"country\":\"Suriname\",\"population\":575991},{\"country\":\"Svalbard and Jan Mayen\",\"population\":2572},{\"country\":\"Sweden\",\"population\":10175214},{\"country\":\"Switzerland\",\"population\":8513227},{\"country\":\"Syria\",\"population\":16906283},{\"country\":\"Tajikistan\",\"population\":9100837},{\"country\":\"Tanzania\",\"population\":56318348},{\"country\":\"Thailand\",\"population\":69428524},{\"country\":\"The Democratic Republic of Congo\",\"population\":84068091},{\"country\":\"Togo\",\"population\":7889094},{\"country\":\"Tokelau\",\"population\":1411},{\"country\":\"Tonga\",\"population\":103197},{\"country\":\"Trinidad and Tobago\",\"population\":1389858},{\"country\":\"Tunisia\",\"population\":11565204},{\"country\":\"Turkey\",\"population\":82319724},{\"country\":\"Turkmenistan\",\"population\":5850908},{\"country\":\"Turks and Caicos Islands\",\"population\":37665},{\"country\":\"Tuvalu\",\"population\":11508},{\"country\":\"Uganda\",\"population\":42723139},{\"country\":\"Ukraine\",\"population\":44622516},{\"country\":\"United Arab Emirates\",\"population\":9630959},{\"country\":\"United Kingdom\",\"population\":66460344},{\"country\":\"United States\",\"population\":326687501},{\"country\":\"United States Minor Outlying Islands\",\"population\":300},{\"country\":\"Uruguay\",\"population\":3449299},{\"country\":\"Uzbekistan\",\"population\":32955400},{\"country\":\"Vanuatu\",\"population\":292680},{\"country\":\"Venezuela\",\"population\":28870195},{\"country\":\"Vietnam\",\"population\":95540395},{\"country\":\"Virgin Islands, British\",\"population\":29802},{\"country\":\"Virgin Islands, U.S.\",\"population\":106977},{\"country\":\"Wales\",\"population\":3139000},{\"country\":\"Wallis and Futuna\",\"population\":15289},{\"country\":\"Western Sahara\",\"population\":652271},{\"country\":\"Yemen\",\"population\":28498687},{\"country\":\"Zambia\",\"population\":17351822},{\"country\":\"Zimbabwe\",\"population\":14439018}]");


// HELPERS
JSON.tryParse = function(value) {
    try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON.tryParse error: ${error}`);
        return null;
    }
};
function $35da740d59af89ba$var$storageAvailable(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && e.name === "QuotaExceededError" && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}
// END HELPERS
const $35da740d59af89ba$var$APP_NAME = "FLAG_QUIZ_1";
const $35da740d59af89ba$var$SETTINGS_HINTTIME = `${$35da740d59af89ba$var$APP_NAME}.userSettings.hintTime`;
// flag data
let $35da740d59af89ba$var$countries = [];
for (let cc of (0, (/*@__PURE__*/$parcel$interopDefault($4fb3636b61cc3534$exports)))){
    if (!cc.country) continue;
    let countryId = cc._country ?? cc.country;
    let continent = (0, (/*@__PURE__*/$parcel$interopDefault($c8658b6091143556$exports))).find((item)=>item.country == countryId)?.continent ?? null;
    if (null == continent || "Antarctica" == continent) continue;
    let population = (0, (/*@__PURE__*/$parcel$interopDefault($b71e50e32221a217$exports))).find((item)=>item.country == countryId).population;
    $35da740d59af89ba$var$countries.push({
        name: cc.country,
        code: cc.abbreviation,
        continent: continent,
        population: population
    });
}
// init main
var $35da740d59af89ba$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    node: document.getElementById("root"),
    flags: {
        countryDtos: $35da740d59af89ba$var$countries
    }
}); /*app.ports.persistSettings.subscribe(function (settings) {
    if (!storageAvailable("localStorage"))
        return;

    localStorage.setItem(SETTINGS_HINTTIME, JSON.stringify(settings.hintTime ?? null));
}); */ 


//# sourceMappingURL=index.be6fc439.js.map
